// Main updated
import React, { useState, useMemo, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Table,
  Nav,
  NavItem,
  NavLink,
  Form,
  Modal,
  Label,
  Input,
} from "reactstrap";

import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
// assets
import Loader from "pages/Separate/Loader";
import moment from "moment";
import NewPagination from "components/Common/Newpagination";
import AddTaskImg from "../../assets/images/Dashboard/AddTaskImg.jpg";
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";
import ReactSelect from "react-select";
import SimpleBar from "simplebar-react";
import "../../assets/css/dashboard.css";
import classnames from "classnames";
import leaveImg2 from "../../assets/images/LeaveDetails.jpg";
import zithasLogo from "../../assets/images/main-zithas.png";
import { priorityOption, TimeOption, colourStyles } from "utils/common-options";
import Notes from "pages/Sales/Lead/EditLead/Notes";
import { fetchNodeData, FetchPostData, FetchNodePostData } from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import Dropzone from "react-dropzone";
import {
  captureScreenshot,
  checkPermissionsByModule,
  convertTimeZone,
  customGlobalFilter,
  filterActivityDate,
  formatBytes,
  getInitials,
  transformGeneralData,
} from "utils/common-helpers";
import AddTasks from "./GeneralTask/AddTasks";
import {
  contractDashboardColumns,
  generalDashboardColumns,
  invoiceDashboardColumns,
  leavesDashboardColumns,
  NewLeadsDashboardColumns,
  projectApprovalColumns,
  ProposalDashboardColumns,
  tenderFollowups,
  rfpApprovalColumns,
} from "utils/columns/Dashboard/dashboardColumns";
import EditTasks from "./GeneralTask/EditTasks";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import PlanMyDay from "./GeneralTask/PlanMyDay";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import AccessDeniedPopup from "routes/AccessDeniedPopup";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ViewContract from "pages/Sales/Contract/ViewContract";
import ViewZithasTechInvoice from "pages/Finance/Invoice/Ztpl/ViewZithasTechInvoice";
import { useDispatch } from "react-redux";
import { setGeneralData } from "store/actions";
import configure from "configure";
import axios from "axios";
import { Tooltip } from "antd";
import Select from "react-select";

import "../../assets/css/Finance/Finance.css";
import "../../assets/css/Work/generalTask.css";

const plannedDayData = async (memberId, date, toggleLoading) => {
  const formDatas = {
    user_id: memberId?.value || localStorage.getItem("auth_id"),
    role_id: secureLocalStorage.getItem("auth_role"),
    type: 2,
    plan_date: moment(date)?.format("YYYY-MM-DD"),
  };
  const response = await FetchPostData(
    toggleLoading,
    "dayPlanReport",
    secureLocalStorage?.getItem("auth_token"),
    formDatas,
  );
  if (response?.data?.success) {
    return response.data.data;
  }
  return false;
};

const TableContainer = React.memo(function TableContainer({
  maincolumns,
  datas,
  allData,
  setAddGeneralTask,
  setPlanedDay,
  toggleLoading,
  storePlanedDayData,
  setAllData,
  onMemberId,
  onGetMember,
  onGetTabType,
  mainAllData,
  onAddTask,
  alldependency,
  isLoading,
  handleChangeStatus,
  onManagePlan,
  type,
  setType,
  tenderTaskModal,
  setTenderTaskModal,
  setTenderData,
  tenderData,
  closeActivities,
  FetchTasks,
  hasRfpAccess,
  submittedRfpStep,
}) {
  const roleID = secureLocalStorage.getItem("auth_role");
  const [data, setData] = useState([]);
  const [filterChange, setFilterChange] = useState(false);
  const [filterActivity, setFilterActivity] = useState(
    roleID == 2 ? "current" : "",
  );
  // const [type, setType] = useState("")
  const [innerType, setInnerType] = useState("");
  const [members, setMembers] = useState(null);
  const [memberId, setMemberId] = useState([]);

  useEffect(() => {
    if (type == "approval") {
      setData(datas);
    } else {
      if (
        (filterChange == false || filterActivity == "current") &&
        roleID == 6
      ) {
        setData(filterActivityDate("current", allData));
      } else {
        if (roleID == 2) {
          setData(filterActivityDate(filterActivity, allData));
        } else {
          setFilterActivity("all");
          setData(datas);
          setColumns(maincolumns);
        }
      }
    }
  }, [datas]);

  const [columns, setColumns] = useState(maincolumns);

  useEffect(() => {
    if (innerType == "contract") {
      setColumns(contractDashboardColumns(onApproveStatus, onViewContract));
    } else if (
      innerType == "zithas" ||
      innerType == "ztpl" ||
      innerType == "tsg"
    ) {
      setColumns(invoiceDashboardColumns(onApproveStatus, onViewinvoice));
    } else if (innerType == "proposal") {
      setColumns(ProposalDashboardColumns(onApproveStatus));
    } else if (innerType == "leave") {
      setColumns(leavesDashboardColumns(onLeaveDetail));
    } else if (innerType == "project") {
      setColumns(projectApprovalColumns());
    } else if (innerType == "new_leads") {
      setColumns(
        NewLeadsDashboardColumns(onOpenLead, removeFromList, onAddTask),
      );
    } else if (innerType == "tender_followups") {
      setColumns(
        tenderFollowups(
          handleChangeTenderStatus,
          onManagePlan,
          onAddTenderTask,
        ),
      );
    } else if (innerType == "rfp_approval") {
      setColumns(rfpApprovalColumns(onRfpApprove));
    } else {
      setColumns(maincolumns);
    }
  }, [innerType]);
  const [leadDetail, setLeadDetail] = useState({});
  const [viewLead, setViewLead] = useState(false);

  const onOpenLead = (obj) => {
    setLeadDetail(obj);
    setViewLead(true);
  };

  const onAddTenderTask = async (data) => {
    setTenderData(data);
    setTenderTaskModal(true);
  };

  const [fixedHeader, setFixedHeader] = useState(false);

  const handleChangeTenderStatus = async (id) => {
    const res = await FetchNodePostData(
      toggleLoading,
      "changeTenderFollowupStatus",
      token,
      { id: id },
    );

    if (res?.data || res?.data?.data) {
      Swal.fire({
        title: "Success",
        text: "Tender Followup Status Changed.",
        icon: "success",
        confirmButtonText: "ok",
      });
      onGetTenderFollowups();
    } else {
      Swal.fire({
        title: "error",
        text: "Failed to updated tender Followup status",
        icon: "error",
        confirmButtonText: "ok",
      });
    }
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      // columns,
      columns,
      data,
      globalFilter: customGlobalFilter,
      autoResetPage: false,
      initialState: {
        sortBy: [
          {
            id: "enddate",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination,
  );
  const { pageIndex, pageSize, globalFilter } = state;

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedHeader(true);
    } else {
      setFixedHeader(false);
    }
  });

  useEffect(() => {
    setPageSize(10);
  }, []);

  const onOpenTodayPlan = async () => {
    const date = new Date();
    const res = await plannedDayData(memberId, date, toggleLoading);
    if (res != false) {
      storePlanedDayData(res);
      setPlanedDay(true);
    }
  };
  const onGetApproval = async (e, type) => {
    e.preventDefault();
    setData([]);
    const res = await fetchNodeData(toggleLoading, `approvalList/${type}`, "");
    if (res?.success) {
      const updatedItems = res?.data?.map((obj) => ({
        ...obj,
        type: 3,
      }));
      setData(updatedItems);
    }
  };

  const onGetRfpApprovals = async (e) => {
    e.preventDefault();
    setData([]);
    setInnerType("rfp_approval");
    setType("approval");

    try {
      const userId = localStorage.getItem("auth_id");
      const res = await axios.get(
        `${configure.nodeApi}/rfp_dashboard/${userId}`,
      );
      if (res.data.success) {
        const mapped = res.data.data.map((rfp) => ({
          ...rfp,
          name: rfp.display_name || "-",
          hours: rfp.timing_total_hrs || "-",
          cost:
            rfp.grand_total > 0
              ? `${rfp.currency_symbol}${rfp.grand_total}`
              : "-",
          type: 3,
        }));
        setData(mapped);
      }
    } catch (err) {
      console.error("RFP dashboard fetch error:", err);
    }
  };

  const onApproveStatus = async (data_id, status, type, unapprove) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${
        status == 0 || unapprove == "2" ? "Disapprove" : "Approve"
      }!`,
      icon: "warning",
      showCancelButton: true,
    }).then(async (willDelete) => {
      if (willDelete.isConfirmed) {
        const formEntries = {
          data_id: data_id,
          status: status,
          type: innerType == "zithas" ? 2 : innerType == "ztpl" ? 3 : type,
          user_id: localStorage.getItem("auth_id"),
        };
        const token = secureLocalStorage.getItem("auth_token");
        const res = await FetchNodePostData(
          toggleLoading,
          "approveList",
          token,
          formEntries,
        );
        if (res?.data?.success) {
          Swal.fire({
            icon: "success",
            text: `${
              type == 2
                ? "Zithas Invoice"
                : type == 4
                ? "TSG Invoice"
                : type == 3
                ? "ZTPL Invoice"
                : type == 5
                ? "Contract"
                : type == 6
                ? "Proposal"
                : ""
            } ${
              status == 0 || unapprove == "2" ? "Disapprove" : "Approved"
            } Successfully ${innerType}`,
          });
          setData(res?.data?.data?.data?.original?.data);
          setApprovalCount(res?.data?.data?.counts?.original?.data);
        }
      }
    });
  };

  const onRfpApprove = async (rfpId, stepStatus) => {
    const s = stepStatus || {};
    let stepToApprove = null;
    let isFinalApproval = false;

    if (s.step2 === "submitted") {
      stepToApprove = 2;
    } else if (s.step3 === "submitted") {
      stepToApprove = 3;
    } else if (s.step4 === "done") {
      isFinalApproval = true;
    }

    if (!stepToApprove && !isFinalApproval) {
      Swal.fire({ icon: "info", text: "No pending step to approve." });
      return;
    }

    const stepLabels = { 2: "L1 (Features)", 3: "L2 (Timing)" };
    const label = isFinalApproval ? "Final RFP" : stepLabels[stepToApprove];

    const { isConfirmed } = await Swal.fire({
      title: `Approve ${label}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve",
      confirmButtonColor: "#752a97",
    });

    if (!isConfirmed) return;

    try {
      if (isFinalApproval) {
        // Final approval — hits update_rfp_status
        const formData = new FormData();
        formData.append("id", rfpId);
        formData.append("status", "approved");
        formData.append("updated_by", localStorage.getItem("auth_id"));

        const res = await axios.post(
          `${configure.nodeApi}/update_rfp_status`,
          formData,
        );

        if (res.data.success) {
          Swal.fire({
            icon: "success",
            text: "RFP Final Approved!",
            timer: 1500,
            showConfirmButton: false,
          });
          onGetRfpApprovals({ preventDefault: () => {} });
        } else {
          Swal.fire({ icon: "error", text: res.data.message });
        }
      } else {
        // Step approval — hits update_rfp_step_status
        const formData = new FormData();
        formData.append("id", rfpId);
        formData.append("step", stepToApprove);
        formData.append("user_id", localStorage.getItem("auth_id"));
        formData.append("status", "approved");

        const res = await axios.post(
          `${configure.nodeApi}/update_rfp_step_status`,
          formData,
        );

        if (res.data.success) {
          Swal.fire({
            icon: "success",
            text: `${label} approved!`,
            timer: 1500,
            showConfirmButton: false,
          });
          onGetRfpApprovals({ preventDefault: () => {} });
        } else {
          Swal.fire({ icon: "error", text: res.data.message });
        }
      }
    } catch (err) {
      console.error("RFP approve error:", err);
      Swal.fire({ icon: "error", text: "Failed to approve" });
    }
  };

  useEffect(() => {
    const fetchAccessData = async () => {
      const auth = sessionStorage.getItem("auth_token");
      const formDataEntries = {
        user_id: localStorage.getItem("auth_id"),
      };
      const datas = await FetchPostData(
        false,
        "/actitvityAccess",
        auth,
        formDataEntries,
      );
      if (datas?.data?.success) {
        if (datas?.data?.data?.length != 0) {
          const options = datas?.data?.data[0]?.members_data?.map((obj) => ({
            value: obj.id,
            label: obj.name,
          }));
          setMembers(options);
          onGetMember(options);
          setMemberId(
            options?.find(
              (obj) => obj?.value == localStorage.getItem("auth_id"),
            ),
          );
          onMemberId(
            options?.find(
              (obj) => obj?.value == localStorage.getItem("auth_id"),
            ),
          );
        } else {
          setMembers([]);
          onGetMember([]);
        }
      }
    };
    fetchAccessData();
  }, []);

  const filterData = async (e, filtertype) => {
    e.preventDefault();
    if (memberId?.length != 0) {
      const auth = sessionStorage.getItem("auth_token");
      const formData = {
        user_id: localStorage.getItem("auth_id"),
        staff_id:
          filtertype == "clear"
            ? localStorage.getItem("auth_id")
            : memberId?.value,
        all_activity: 1,
      };
      const response = await FetchNodePostData(
        toggleLoading,
        "teamsActivity",
        auth,
        formData,
      );
      if (response?.status == 200) {
        const tasks = response?.data?.tasks?.map((obj) => ({
          ...obj,
          type: 1,
        }));
        const follows = response?.data?.followups?.map((obj) => ({
          ...obj,
          type: 2,
        }));
        const mainData = [...tasks, ...follows];
        const filteredData = mainData.filter((item) => {
          return item.status != "complete" && item.status != "mark-completed";
        });
        setAllData(filteredData);
        setColumns(maincolumns);

        switch (type) {
          case "task":
            setData(filteredData?.filter((obj) => obj?.type == 1));
            break;
          case "follow":
            setData(filteredData?.filter((obj) => obj?.type == 2));
            break;
          case "new":
            setData(filteredData?.filter((obj) => obj?.enddate == null));
            break;

          case "assigned":
            setData(
              filteredData?.filter(
                (item) =>
                  item.type == 1 &&
                  item.added_by != localStorage.getItem("auth_id"),
              ),
            );
            break;
          default:
            setData(filteredData);
        }
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: "Please select all mandatory field.",
      });
    }
  };

  // Applied Leaves
  const [leaveDetail, setLeaveDetails] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [leaveId, setLeaveId] = useState("");
  const [details, setDetails] = useState({});
  const [reason, setReason] = useState("");
  const [reasons, setReasons] = useState("");
  const [staffId, setStaffId] = useState("");
  const [leaveSlots, setLeaveSlots] = useState([]);
  const [allLeave, setAllLeave] = useState([]);
  const [slotId, setSlotId] = useState("");
  const [addReasons, setAddReasons] = useState(false);
  const [tabType, setTabType] = useState(false);

  const onLeaveDetail = async (id, staff_id) => {
    const res = await fetchNodeData(toggleLoading, `LeaveSlots/${id}`, "");
    if (res?.success) {
      setLeaveDetails(true);
      setLeaveId(id);
      setDetails(res?.data);
      setReason(res?.data?.leaveslots[0]?.comment);
      setLeaveSlots(res?.data?.leaveslots);
      setAllLeave(res?.data?.leaveslots);
      setStaffId(staff_id);
    }
  };

  const onChangeStatus = async (id, status, disapprove) => {
    const formEnties = {
      data_id: id,
      status: status,
      type: 1,
      leave_reason: disapprove ? reasons : "",
    };
    const res = await FetchNodePostData(
      toggleLoading,
      `approveList`,
      "",
      formEnties,
    );
    if (res?.data?.success) {
      setAddReasons(false);
      setReasons("");
      Swal.fire({
        icon: "success",
        text: `Leave Approved Successfully`,
      }).then(async (data) => {
        const response = await fetchNodeData(
          toggleLoading,
          `LeaveSlots/${leaveId}`,
          "",
        );
        if (response?.success) {
          setLeaveSlots(response?.data?.leaveslots);
          setAllLeave(response?.data?.leaveslots);
        }
      });
    }
  };
  const onGetHisory = async () => {
    const res = await fetchNodeData(toggleLoading, `LeaveHistory/${staffId}`, "");
    if (res?.success) {
      setLeaveSlots(res?.data?.leaveslots);
      setShowHistory(true);
    }
  };
  const [viewContract, setViewContract] = useState(false);
  const [viewInvoice, setViewInvoice] = useState(false);
  const [contractId, setContractId] = useState("");
  const [invoiceDetail, setInvoiceDetail] = useState({});
  const onViewContract = (id) => {
    setViewContract(true);
    setContractId(id);
  };
  const onViewinvoice = async (id) => {
    const res = await fetchNodeData(
      toggleLoading,
      `invoiceData/${id}/${
        innerType == "ztpl"
          ? 1
          : innerType == "zithas"
          ? 2
          : innerType == "tsg"
          ? 3
          : ""
      }`,
      "",
    );
    if (res?.success) {
      setInvoiceDetail(res?.data);
      setViewInvoice(true);
    }
  };
  const [approvalCount, setApprovalCount] = useState({});
  const [tfollowups, setTenderCount] = useState(0);

  useEffect(() => {
    const FetchCount = async () => {
      const response = await fetchNodeData(
        false,
        `approvalCounts/${localStorage.getItem("auth_id")}`,
        "",
      );
      if (response?.success) {
        const count = response?.data;
        setApprovalCount(count);
      }
    };
    FetchCount();

    const onGetTenderFollowupscounts = async () => {
      const res = await fetchNodeData(
        false,
        `tenderFollowupss/${localStorage.getItem("auth_id")}`,
        token,
      );

      if (res?.success || res?.data?.success || res?.data?.data?.success) {
        setTenderCount(res?.data?.length);
      }
    };
    onGetTenderFollowupscounts();
  }, []);

  const getPersonalData = async (tab_type) => {
    const token = secureLocalStorage.getItem("auth_token");
    const userId = localStorage.getItem("auth_id");
    if (tab_type) {
      const res = await fetchNodeData(
        toggleLoading,
        `personaltasks/${userId}`,
        token,
      );
      if (res) {
        setColumns(maincolumns);
        setType("task");
        setInnerType("");
        gotoPage(0);
        const tasks = res?.tasks?.map((obj) => ({
          ...obj,
          type: 1,
        }));
        setData(tasks);
        setAllData(tasks);
      }
    } else {
      switch (type) {
        case "task":
          setData(mainAllData?.filter((obj) => obj?.type == 1));
          break;
        case "follow":
          setData(mainAllData?.filter((obj) => obj?.type == 2));
          break;
        case "new":
          setData(mainAllData?.filter((obj) => obj?.enddate == null));
          break;
        case "assigned":
          setData(
            mainAllData?.filter(
              (item) =>
                item.type == 1 &&
                item.added_by != localStorage.getItem("auth_id"),
            ),
          );
          break;
        default:
          setData(mainAllData?.filter((obj) => obj?.type == 1));
      }
      setAllData(mainAllData);
    }
  };

  const token = secureLocalStorage.getItem("auth_token");
  const onGetNewLead = async () => {
    const res = await fetchNodeData(
      toggleLoading,
      `newLeads/${localStorage.getItem("auth_id")}`,
      token,
    );
    if (res?.success) {
      setData(res?.data);
      setInnerType("new_leads");
      setType("");
    }
  };

  const onGetTenderFollowups = async () => {
    const res = await fetchNodeData(
      toggleLoading,
      `tenderFollowupss/${localStorage.getItem("auth_id")}`,
      token,
    );

    if (res?.success || res?.data?.success || res?.data?.data?.success) {
      setData(res?.data?.data || res?.data || res);
      setInnerType("tender_followups");
      setType("");
    }
  };

  const removeFromList = (leadId) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure ?",
      text: "You Want to Remove from List",
      showCancelButton: true,
    }).then(async (data) => {
      if (data?.isConfirmed) {
        const formEntries = {
          user_id: localStorage.getItem("auth_id"),
          lead_id: leadId,
        };
        const res = await FetchNodePostData(
          toggleLoading,
          "removeLead",
          token,
          formEntries,
        );
        if (res?.data?.success) {
          Swal.fire({
            icon: "success",
            title: "Lead Removed Successfully",
          }).then(() => {
            setData(res?.data?.data?.original?.data);
          });
        }
      }
    });
  };

  const [newLead, setNewLead] = useState(false);
  const [comunicator, setComunicator] = useState([]);

  useEffect(() => {
    const getCommunicator = async () => {
      const res = await fetchNodeData(false, "allLeadsAccess", token);
      if (res?.success) {
        const resData = res?.data;
        setComunicator(res?.data);
        const isInvolved = resData.some(
          (item) => item.member_id == localStorage.getItem("auth_id"),
        );
        setNewLead(isInvolved);
      }
    };
    getCommunicator();
  }, []);

  const [isNote, setIsNote] = useState(false);
  const [taskName, setTaskName] = useState("");
  const [priority, setPriority] = useState([]);
  const [assignee, setAssignee] = useState([]);
  const [noteDescription, setNoteDescription] = useState("");
  const [selectedFiles1, setselectedFiles1] = useState([]);

  function handleAcceptedFiles1(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );
    setselectedFiles1(files);
  }

  const onActionNewLead = async (e) => {
    e.preventDefault();
    if (noteDescription != "") {
      if (isNote) {
        const formDatas = {
          user_id: localStorage.getItem("auth_id"),
          title: taskName,
          assigned: assignee?.value,
          priority: priority?.value,
          related: "sales",
          related_to: "lead",
          related_id: leadDetail.id,
          description: noteDescription,
          type: 2,
          copynotes: true,
        };
        const response = await FetchNodePostData(
          toggleLoading,
          "addGeneralTasks",
          secureLocalStorage.getItem("auth_token"),
          formDatas,
        );
        if (response?.data?.success) {
          Swal.fire({
            icon: "success",
            text: "Note Added & Task Added Successfully.",
          }).then(() => {
            setViewLead(false);
            onGetNewLead();
          });
        }
      } else {
        toggleLoading(true);
        const formData = new FormData();
        formData.append("lead_id", leadDetail.id);
        formData.append("user_id", localStorage.getItem("auth_id"));
        formData.append("description", noteDescription);
        for (let i = 0; i < selectedFiles1.length; i++) {
          formData.append("files[]", selectedFiles1[i]);
        }
        try {
          const response = await axios({
            method: "post",
            url: `${configure.nodeApi}/add_lead_note`,
            data: formData,
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          }).then((response) => {
            toggleLoading(false);
            Swal.fire({
              icon: "success",
              text: "Note Added  Successfully.",
            }).then(() => {
              // setViewLead(false)
              onGetNewLead();
              setNoteDescription("");
              setselectedFiles1([]);
            });
          });
        } catch (error) {
          console.log(error);
          toggleLoading(false);
        }
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: "Please add a note description.",
      });
    }
  };

  const onAddNoteFunction = async (e) => {
    e.preventDefault();
  };

  const safeJSONParse = (data) => {
    try {
      return typeof data === "string" ? JSON.parse(data || "[{}]") : data;
    } catch (e) {
      return null;
    }
  };

  const personDetails = safeJSONParse(leadDetail?.person_details);
  const person = Array.isArray(personDetails) ? personDetails[0] : null;

  const allRoles = useSelector((state) => state?.Roles?.apiData);
  const [roles, setRoles] = useState([]);
  function filterInnerArraysById(id) {
    return roles.map((innerArray) => {
      return innerArray.filter((element) => {
        const parts = element.split(",");
        const elementId = parseInt(parts[0]);
        return elementId === id;
      });
    });
  }

  useEffect(() => {
    setRoles(allRoles.map((item) => JSON.parse(item.permission)));
  }, []);

  return (
    <div>
      <Row>
        <Col xl="12">
          <div className="card-body">
            <div className={`${closeActivities && "dashboard-controls-fixed"}`}>
              <div className="d-flex justify-content-between align-items-center mb-4 gap-5">
                <div className="  mb-3 text-purple fs-5 fw-bold d-flex gap-2">
                  My Activities
                  {localStorage?.getItem("auth_id") == 32 ||
                  localStorage?.getItem("auth_id") == 1 ||
                  localStorage?.getItem("auth_id") == 4 ? (
                    <a
                      className={`d-flex gap-3 align-items-center general-box ms-3 ${
                        tabType ? "bg-dark " : ""
                      }`}
                      onClick={() => {
                        setTabType(!tabType);
                        onGetTabType(!tabType);
                        getPersonalData(!tabType);
                      }}
                    >
                      <h5
                        className={`text-${tabType ? "white" : "purple"} mb-0 `}
                      >
                        <input
                          type="checkbox"
                          className="me-2 "
                          style={{ accentColor: "white" }}
                          checked={tabType}
                        />
                        Personal Tab
                      </h5>
                    </a>
                  ) : null}
                  <a
                    className={`d-flex gap-3 align-items-center general-box ms-3 px-2 ${
                      type === "assigned" ? "bg-purple " : ""
                    }`}
                    onClick={() => {
                      setData(
                        allData?.filter(
                          (item) =>
                            item.type == 1 &&
                            item.added_by != localStorage.getItem("auth_id"),
                        ),
                      );
                      setInnerType("");
                      setType("assigned");
                    }}
                  >
                    <h5 className="text-purple mb-0 ">
                      <input
                        type="checkbox"
                        className="me-2 "
                        style={{ accentColor: "white" }}
                        checked={type === "assigned"}
                      />
                      Assigned By Others
                    </h5>
                  </a>
                </div>
                <div
                  className="search-box d-flex justify-content-end align-items-center gap-2"
                  style={{ flex: 1 }}
                >
                  <select
                    className="border-radius form-select"
                    style={{ width: "100px" }}
                    value={pageSize}
                    onChange={(e) => setPageSize(e.target.value)}
                  >
                    {[10, 25, 50, 100].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        Show {pageSize}
                      </option>
                    ))}
                  </select>
                  <div className="position-relative col-5">
                    <label
                      htmlFor="search-bar-0"
                      className="search-label w-100 mb-0"
                    >
                      <span id="search-bar-0-label" className="sr-only">
                        Search this table
                      </span>
                      <input
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        id="search-bar-0"
                        type="text"
                        className="  form-control rounded-pill h-100"
                        placeholder={`Search...`}
                        value={globalFilter || ""}
                      />
                    </label>
                    <i className="bx bx-search-alt search-icon"></i>
                  </div>
                  {members?.length != 0 && members != null ? (
                    <>
                      <div className="col-2">
                        <ReactSelect
                          placeholder="Member"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={members}
                          value={memberId}
                          onChange={(e) => {
                            setMemberId(e);
                            onMemberId(e);
                          }}
                        />
                      </div>
                      <button
                        className="btn btn-sm bg-purple text-white"
                        onClick={(e) => filterData(e)}
                        style={{ borderRadius: "5px" }}
                      >
                        <i className="bi bi-funnel-fill fs-5"></i>
                      </button>
                      <a
                        className="btn btn-sm fs-5 me-1 bg-warning text-white"
                        style={{ borderRadius: "5px" }}
                        onClick={(e) => {
                          setMemberId([]);
                          onMemberId([]);
                          setData(mainAllData);
                          setInnerType("");
                          setColumns(maincolumns);
                          filterData(e, "clear");
                        }}
                      >
                        <i className="fas fa-undo "></i>
                      </a>
                    </>
                  ) : null}
                  {closeActivities && (
                    <div onClick={() => closeActivities(false)}>
                      {/* <i className="fa fa-times text-red"></i> */}
                      <button type="button" className="btn-modal-close">
                        <span aria-hidden="true" className="btn-modal-span">
                          ×
                        </span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <Row className="mb-2">
                <div className="mb-3 col-6 mb-md-0 d-flex ">
                  <div className="col-md-12">
                    <div
                      className="row align-items-center"
                      style={{ gap: "12px 0" }}
                    >
                      <div className="col-4">
                        <a
                          className={`d-flex gap-3 align-items-center justify-content-between px-2 general-box ${
                            type == "task" ? "bg-purple " : ""
                          }`}
                          onClick={() => {
                            setInnerType("");
                            setColumns(maincolumns);
                            setType("task");

                            const hasTasks = mainAllData?.some(
                              (item) => item?.type == 1,
                            );

                            if (hasTasks) {
                              const baseData = mainAllData.filter(
                                (obj) => obj?.type == 1,
                              );

                              setData(
                                filterActivityDate(filterActivity, baseData),
                              );
                            } else {
                              FetchTasks(1);
                            }
                          }}
                        >
                          <h5 className="text-purple mb-0 lh-sm">
                            <input
                              type="checkbox"
                              className="me-2 "
                              style={{ accentColor: "white" }}
                              checked={type == "task"}
                            />
                            Tasks
                          </h5>
                          <h5 className="text-primary mb-0">
                            {allData?.filter((obj) => obj?.type == 1)?.length}
                          </h5>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className={`d-flex gap-3 align-items-center justify-content-between px-2 general-box ${
                            type == "follow" ? "bg-purple " : ""
                          }`}
                          onClick={() => {
                            setInnerType("");
                            setType("follow");

                            const hasFollowups = mainAllData?.some(
                              (item) => item?.type == 2,
                            );

                            if (hasFollowups) {
                              const baseData = mainAllData.filter(
                                (obj) => obj?.type == 2,
                              );

                              setData(
                                filterActivityDate(filterActivity, baseData),
                              );
                            } else {
                              FetchTasks(2, "follow");
                            }
                          }}
                        >
                          <h5 className="text-purple mb-0">
                            <input
                              type="checkbox"
                              className="me-2 "
                              style={{ accentColor: "white" }}
                              checked={type == "follow"}
                            />
                            Follow Ups
                          </h5>
                          <h5 className="text-primary mb-0">
                            {allData?.filter((obj) => obj?.type == 2)?.length}
                          </h5>
                        </a>
                      </div>
                      <div className="col-4">
                        <a
                          className={`d-flex gap-3 align-items-center justify-content-between px-2 general-box bg-light-red cursor-pointer ${
                            type == "new" ? "bg-purple" : ""
                          }`}
                          onClick={(e) => {
                            setColumns(maincolumns);

                            const baseData = allData?.filter(
                              (obj) => obj?.enddate == null,
                            );

                            setType("new");
                            setData(
                              filterActivityDate(filterActivity, baseData),
                            );

                            setInnerType("");
                          }}
                        >
                          <h5 className="text-danger mb-0">
                            <input
                              type="checkbox"
                              className="me-2 "
                              style={{ accentColor: "white" }}
                              checked={type == "new"}
                            />
                            New
                          </h5>
                          <h5 className="text-danger mb-0">
                            {innerType != "new_leads"
                              ? allData?.filter((obj) => obj?.enddate == null)
                                  ?.length
                              : "0"}
                          </h5>
                        </a>
                      </div>
                      {localStorage.getItem("auth_id") == 32 ||
                      localStorage.getItem("auth_id") == 1 ? (
                        <div className="col-4">
                          <div
                            className={`nav-item dropdown approval-list px-0 general-box cursor-pointer ${
                              type == "approval" ? "bg-purple " : ""
                            }`}
                          >
                            <h5 className="text-purple mb-0 d-flex align-items-center justify-content-between px-2">
                              <span>
                                <input
                                  type="checkbox"
                                  className="me-2 "
                                  style={{ accentColor: "white" }}
                                  checked={type == "approval"}
                                />
                                Approval :
                              </span>
                              <span>
                                {Number(approvalCount?.proposal) +
                                  Number(approvalCount?.ztpl) +
                                  Number(approvalCount?.zithas) +
                                  Number(approvalCount?.contract) +
                                  Number(approvalCount?.leaves)}
                              </span>
                            </h5>
                            <div
                              className="dropdown-menu "
                              style={{ right: 0, top: "100%" }}
                            >
                              <a
                                className={`dropdown-item ${
                                  innerType == "ztpl"
                                    ? "bg-purple text-puple"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  setInnerType("ztpl");
                                  if (type !== "approval") setType("approval");
                                  onGetApproval(e, "3");
                                }}
                              >
                                ZTPL Invoice - {approvalCount?.ztpl}
                              </a>
                              {/* <a
                        className={`dropdown-item ${
                          innerType == "tsg" ? "bg-purple text-puple" : ""
                        }`}
                        onClick={e => {
                          setInnerType("tsg")
                          onGetApproval(e, "4")
                        }}
                      >
                        TSG Invoice - {approvalCount?.tsg}
                      </a> */}
                              <a
                                className={`dropdown-item ${
                                  innerType == "zithas"
                                    ? "bg-purple text-puple"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  setInnerType("zithas");
                                  if (type !== "approval") setType("approval");
                                  onGetApproval(e, "2");
                                }}
                              >
                                Zithas Invoice - {approvalCount?.zithas}
                              </a>
                              <a
                                className={`dropdown-item ${
                                  innerType == "contract"
                                    ? "bg-purple text-puple"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  setInnerType("contract");
                                  if (type !== "approval") setType("approval");
                                  onGetApproval(e, "5");
                                }}
                              >
                                Contracts - {approvalCount?.contract}
                              </a>
                              <a
                                className={`dropdown-item ${
                                  innerType == "proposal"
                                    ? "bg-purple text-puple"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  setInnerType("proposal");
                                  if (type !== "approval") setType("approval");
                                  onGetApproval(e, "6");
                                }}
                              >
                                Proposal - {approvalCount?.proposal}
                              </a>
                              <a
                                className={`dropdown-item ${
                                  innerType == "leave"
                                    ? "bg-purple text-puple"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  setInnerType("leave");
                                  if (type !== "approval") setType("approval");
                                  onGetApproval(e, "1");
                                }}
                              >
                                Applied Leaves - {approvalCount?.leaves}
                              </a>
                              <a
                                className={`dropdown-item ${
                                  innerType == "project"
                                    ? "bg-purple text-puple"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  setInnerType("project");
                                  if (type !== "approval") setType("approval");
                                  onGetApproval(e, "7");
                                }}
                              >
                                Projects
                              </a>
                              {hasRfpAccess && (
                                <a
                                  className={`dropdown-item ${
                                    innerType == "project"
                                      ? "bg-purple text-puple"
                                      : ""
                                  }`}
                                  onClick={(e) => {
                                    onGetRfpApprovals(e);
                                  }}
                                >
                                  RFP Approvals
                                  {submittedRfpStep?.length > 0 && (
                                    // <span className="badge bg-danger ms-2">
                                    <span> - {submittedRfpStep.length}</span>
                                    // </span>
                                  )}
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div className="col-4">
                        {newLead ? (
                          <div>
                            <a
                              className={`d-flex gap-3 align-items-center justify-content-between px-2 general-box bg-light-red cursor-pointer ${
                                innerType == "new_leads"
                                  ? "bg-purple text-puple"
                                  : ""
                              }`}
                              onClick={(e) => {
                                onGetNewLead();
                              }}
                            >
                              <h5 className="text-danger mb-0">
                                <input
                                  type="checkbox"
                                  className="me-2 "
                                  style={{ accentColor: "white" }}
                                  checked={innerType == "new_leads"}
                                />
                                New Leads
                              </h5>
                              <h5 className="text-danger mb-0">
                                {approvalCount?.newLeads}
                              </h5>
                            </a>
                          </div>
                        ) : null}
                      </div>
                      {filterInnerArraysById(87)
                        .map((item) => item[0]?.split(",").map(Number)[2])
                        .includes(1) == true ? (
                        <div className="col-4">
                          <a
                            className={`d-flex gap-1 align-items-center justify-content-between px-2 general-box cursor-pointer ${
                              innerType == "tender_followups"
                                ? "bg-purple text-purple"
                                : ""
                            }`}
                            onClick={(e) => {
                              // if(!data.length) return
                              onGetTenderFollowups();
                            }}
                          >
                            <h5 className="text-purple mb-0">
                              <input
                                type="checkbox"
                                className="me-2 "
                                style={{ accentColor: "white" }}
                                checked={innerType == "tender_followups"}
                              />
                              Tender Follow Ups
                            </h5>
                            <h5 className="text-purple mb-0">
                              {tfollowups || 0}
                            </h5>
                          </a>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="col-6 d-flex justify-content-end align-items-center gap-3">
                  <div className=" ">
                    <div className="">
                      {/* {innerType != "new_leads" ? (
                        <select
                          className="form-select w-100"
                          style={{ fontSize: "14px" }}
                          value={filterActivity}
                          onChange={e => {
                            console.log("allData: ", allData);
                            setData(filterActivityDate(e.target.value, allData))
                            setFilterActivity(e.target.value)
                            setFilterChange(true)
                          }}
                        >
                          <option value="all">All Activities</option>
                          <option value="current">Today's Activities</option>
                          <option value="future">Future Activities</option>
                          <option value="past">Past Activities</option>
                        </select>
                      ) : null} */}

                      {/* SMART DATE FILTER - Respects Current View (Tender Followups, New Leads, etc.) */}
                      {![
                        "new_leads",
                        "leave",
                        "contract",
                        "proposal",
                        "ztpl",
                        "zithas",
                        "tsg",
                        "project",
                        "tender_followups",
                      ].includes(innerType) && (
                        <select
                          className="form-select w-100"
                          style={{ fontSize: "14px" }}
                          value={filterActivity}
                          onChange={(e) => {
                            const value = e.target.value;
                            gotoPage(0);
                            let baseData = [];

                            switch (type) {
                              case "task":
                                baseData = allData?.filter(
                                  (obj) => obj?.type == 1,
                                );
                                break;
                              case "follow":
                                baseData = allData?.filter(
                                  (obj) => obj?.type == 2,
                                );
                                break;
                              case "new":
                                baseData = allData?.filter(
                                  (obj) => obj?.enddate == null,
                                );
                                break;
                              case "assigned":
                                baseData = allData?.filter(
                                  (item) =>
                                    item.type == 1 &&
                                    item.added_by !=
                                      localStorage.getItem("auth_id"),
                                );

                                break;

                              default:
                                baseData = [...allData];
                            }

                            const filtered =
                              value === "all"
                                ? baseData
                                : (() => {
                                    const result = filterActivityDate(
                                      value,
                                      baseData,
                                    );
                                    return result;
                                  })();
                            setData(filtered);
                            setFilterActivity(value);

                            setFilterChange(true);
                          }}
                        >
                          <option value="all">All Activities</option>
                          <option value="current">Today's Activities</option>
                          <option value="future">Future Activities</option>
                          <option value="past">Past Activities</option>
                        </select>
                      )}

                      {/* <div className="position-relative">
                        <label
                          htmlFor="search-bar-0"
                          className="search-label w-100 mb-0"
                        >
                          <span id="search-bar-0-label" className="sr-only">
                            Search this table
                          </span>
                          <input
                            onChange={e => setGlobalFilter(e.target.value)}
                            id="search-bar-0"
                            type="text"
                            className="border-radius form-control rounded h-100"
                            placeholder={`Search...`}
                            value={globalFilter || ""}
                          />
                        </label>
                        <i className="bx bx-search-alt search-icon"></i>
                      </div> */}
                    </div>
                  </div>

                  <Link
                    onClick={() => setAddGeneralTask(true)}
                    className="s btn text-white me-0 btn-save btn-label "
                  >
                    <i className="fas fa-plus me-2 icon-size label-icon"></i>
                    Activity
                  </Link>

                  <Link
                    onClick={() => {
                      onOpenTodayPlan();
                    }}
                    className="s btn text-white me-0 btn-primary btn-label "
                  >
                    <i className="bi bi-calendar-day me-2 icon-size label-icon"></i>
                    Plan My Day
                  </Link>
                </div>
              </Row>
            </div>

            <div className="position-relative table-responsive">
              <Table className="table table-bordered mt-4" {...getTableProps()}>
                <thead
                  className={`${
                    fixedHeader && page.length >= 5
                      ? "fixed_view_payment_table"
                      : ""
                  }`}
                >
                  {headerGroups.map((headerGroup, i) => (
                    <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, index) => (
                        <th
                          key={index}
                          className={`t-col-${index + 1} ${column.className}`}
                          {...column.getHeaderProps(
                            column.getSortByToggleProps(),
                          )}
                        >
                          <div className="d-flex align-items-center">
                            <span className="flex-grow-1 text-center header-text">
                              {column.render("Header")}
                            </span>
                            {column.isShortIcon && (
                              <span
                                onClick={() =>
                                  column.getSortByToggleProps().onClick()
                                }
                                className="d-flex align-items-center ms-2"
                              >
                                <i
                                  title="Ascending"
                                  className={`bi bi-arrow-up info-icon ${
                                    column.isSorted && !column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                                <i
                                  title="Descending"
                                  className={`bi bi-arrow-down info-icon ${
                                    column.isSorted && column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                              </span>
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody
                  className="fix-introducer-headers"
                  {...getTableBodyProps()}
                >
                  {page.map((row, i) => {
                    prepareRow(row);
                    const isPassedDate =
                      new Date(row.original?.enddate) < new Date();
                    return (
                      <tr
                        className={`row-hover ${
                          row?.original?.type == 2 ? "bg-orange-task" : ""
                        } `}
                        {...row.getRowProps()}
                        key={i}
                      >
                        {row.cells.map((cell, index) => {
                          return (
                            <td
                              key={index}
                              className={`t-col-${index + 1}   ${
                                cell.column.className
                              } ${isPassedDate ? "bg-light-red" : ""} 
                              ${
                                row.original?.status == "mark-completed"
                                  ? "bg-green"
                                  : ""
                              }
                             `}
                              {...cell.getCellProps()}
                            >
                              {cell.render("Cell")}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
            <Row className="justify-content-md-end justify-content-center align-items-center">
              <NewPagination
                gotoPage={gotoPage}
                canPreviousPage={canPreviousPage}
                previousPage={previousPage}
                canNextPage={canNextPage}
                pageIndex={pageIndex}
                pageOptions={pageOptions}
                pageSize={pageSize}
                page={page}
                data={data}
                nextPage={nextPage}
              />
            </Row>
          </div>
        </Col>
      </Row>

      <Modal isOpen={leaveDetail} size="xl" className="" centered>
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">Leave Details</h5>
          <button
            type="button"
            onClick={() => {
              setLeaveDetails(false);
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>

        <div className="modal-body pe-4 my-3">
          <Form className="row d-flex justify-content-center align-items-center">
            <div className="col-md-5 d-flex flex-column justify-content-end align-items-center ps-3 gap-4">
              <div className="text-center">
                <img src={leaveImg2} alt="Addepe" style={{ width: "70%" }} />
              </div>
            </div>

            <div className="col-md-7 d-flex flex-column justify-content-start  gap-3">
              <div className="col-md-12 d-flex flex-row mb-3 mt-2 gap-3">
                <div className="col-md-12 d-flex justify-content-start align-items-center gap-3">
                  <h5 className="mb-0">Leave Balance :</h5>
                  <div className="d-flex justify-content-between align-items-center gap-3 col-md-9">
                    <div className="d-flex gap-3 justify-content-start align-items-center">
                      <span className="mb-0 px-3 py-1  bg-primary rounded text-light">
                        <b>
                          EL :{" "}
                          <span>
                            {details?.earned_leave} ({details?.ael})
                          </span>
                        </b>
                      </span>
                      <span className="mb-0 px-3 py-1 rounded  bg-primary text-light">
                        <b>
                          CL :{" "}
                          <span>
                            {details?.casual_leave} ({details?.acl})
                          </span>
                        </b>
                      </span>
                      <span className="mb-0 px-3 py-1 rounded  bg-primary text-light">
                        <b>
                          SL :{" "}
                          <span>
                            {details?.sick_leave} ({details?.asl})
                          </span>
                        </b>
                      </span>
                    </div>
                    <div>
                      <span
                        className="mb-0 px-3 py-1 rounded  bg-success text-light cursor-pointer"
                        onClick={() => {
                          if (showHistory) {
                            setLeaveSlots(allLeave);
                            setShowHistory(false);
                          } else {
                            onGetHisory();
                          }
                        }}
                      >
                        <b>
                          <i
                            className={
                              showHistory ? "fab fa-rev" : "fa fa-history"
                            }
                          ></i>
                        </b>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {showHistory == false && (
                <div className="col-12 mb-3">
                  <label className="">Reasons</label>
                  <textarea className="form-control" value={reason} disabled />
                </div>
              )}
              <div className="d-flex flex-column gap-1">
                <h5 className="mb-0 ps-1 mb-2">
                  {showHistory ? "Leave Slots" : "Leave history"} :{" "}
                </h5>
                <div className="table-responsive col-md-12 leave-history-table">
                  <Table className="table mb-0">
                    <thead
                      className="bg-white"
                      style={{ position: "sticky", top: 0 }}
                    >
                      <tr className=" ">
                        <th className="header text-center col-1">Leave Date</th>
                        <th className="header col-1">Type</th>
                        <th className="header col-1">Status</th>
                        <th
                          className="text-center header"
                          style={{ width: "10%" }}
                        >
                          {showHistory ? "Reason" : "Action"}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="">
                      {leaveSlots?.map((obj, i) => {
                        return (
                          <tr key={i}>
                            <th scope="row" className="text-center">
                              {obj?.leave_dates}
                            </th>
                            <td>{obj?.sub_leave_name}</td>
                            <td>{obj?.leave_status}</td>
                            <td
                              className="word-wrap text-center"
                              style={{ width: "10%" }}
                            >
                              {showHistory ? (
                                obj?.comment
                              ) : (
                                <>
                                  {obj?.status != 1 ? (
                                    <>
                                      <a
                                        className="btn btn-sm btn-outline-primary me-1 lh-1 p-1"
                                        title="Approve"
                                        onClick={() =>
                                          onChangeStatus(
                                            obj?.slots_id,
                                            "Approved",
                                          )
                                        }
                                      >
                                        <i className="bi bi-check-lg icon-center"></i>
                                      </a>
                                      <a
                                        className="btn btn-sm btn-outline-danger me-1 lh-1 p-1"
                                        title="Disapprove"
                                        onClick={() => {
                                          setSlotId(obj?.slots_id);
                                          setAddReasons(true);
                                        }}
                                      >
                                        <i className="dripicons-cross icon-center"></i>
                                      </a>
                                    </>
                                  ) : (
                                    <>
                                      {obj?.leave_reason || (
                                        <i className="fa fa-thumbs-up text-primary"></i>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Modal>

      <Modal
        size="xl"
        centered
        isOpen={viewContract}
        className="modal-fullscreen"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Contract Detail</h5>
          <div className="d-flex align-items-center">
            <button
              type="button"
              onClick={() => {
                setViewContract(false);
              }}
              className="btn-modal-close"
              style={{ marginTop: "8px" }}
            >
              <span aria-hidden="true" className="btn-modal-span">
                &times;
              </span>
            </button>
          </div>
        </div>
        <div className="modal-body">
          <Row>
            <ViewContract view={true} id={contractId} />
          </Row>
        </div>
      </Modal>

      <Modal
        size="xl"
        centered
        isOpen={viewInvoice}
        className="modal-fullscreen"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Contract Detail</h5>
          <div className="d-flex align-items-center">
            <button
              type="button"
              onClick={() => {
                setViewInvoice(false);
              }}
              className="btn-modal-close"
              style={{ marginTop: "8px" }}
            >
              <span aria-hidden="true" className="btn-modal-span">
                &times;
              </span>
            </button>
          </div>
        </div>
        <div className="modal-body">
          <Row>
            <ViewZithasTechInvoice invoiceDetail={invoiceDetail} />
          </Row>
        </div>
      </Modal>

      <div className={`note-sticky-form ${addReasons ? "d-block" : "d-none"}`}>
        <Draggable>
          <ResizableBox
            width={500}
            style={{
              position: "absolute",
              top: "10%",
              right: "2%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <div className="justify-content-between  d-flex mb-3">
              <h5 className="modal-title mt-0">Add Reason</h5>
              <button
                type="button"
                onClick={() => {
                  setAddReasons(false);
                }}
                className="btn-modal-close"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  &times;
                </span>
              </button>
            </div>
            <form
              className="mt-4"
              onSubmit={(e) => {
                e.preventDefault();
                onChangeStatus(slotId, "Unapproved", true);
              }}
            >
              <div className="col-md-12 mt-4 mb-3">
                <label>Reason</label>
                <textarea
                  className="form-control"
                  placeholder="Reason for Disapproval"
                  value={reasons}
                  onChange={(e) => setReasons(e.target.value)}
                  required
                />
              </div>
              <div className="col-md-3 mt-3">
                <button className=" btn btn-save btn-label">
                  <i className="fas fa-save me-2 label-icon"></i> save
                </button>
              </div>
            </form>
          </ResizableBox>
        </Draggable>
      </div>

      <Modal isOpen={viewLead} size="xl" className="bd-modal-lead" centered>
        {isLoading && <Loader />}
        <div className="modal-header">
          <h5 className="modal-title mt-0">Lead Details</h5>
          <div>
            <button
              className="btn btn-red  me-2"
              onClick={() => removeFromList(leadDetail?.id)}
            >
              Remove from List
            </button>

            <button
              type="button"
              onClick={() => setViewLead(false)}
              className="btn-modal-close"
            >
              <span aria-hidden="true" className="btn-modal-span">
                ×
              </span>
            </button>
          </div>
        </div>
        <div
          className="modal-body"
          style={{ maxHeight: "75vh", overflowY: "auto" }}
        >
          <div className="row">
            <div className="col-md-7">
              <div className="d-flex justify-content-between align-items-end">
                <div>
                  <h3 className="text-purple fw-bold font-size-30 mb-2">
                    {leadDetail?.company}
                  </h3>
                  <div className="d-flex gap-3">
                    {/* <p className="mb-2">
                      <strong className="text-purple">Name:</strong> {""}
                      {(leadDetail?.person_details)
                        ? JSON.parse(leadDetail?.person_details)[0]?.person_name
                          ? JSON.parse(leadDetail?.person_details)[0]
                            .person_name
                          : "-"
                        : "-"}
                    </p>
                    <p className="mb-2">
                      <strong className="text-purple">Email: </strong>
                      {""}
                      {leadDetail?.email}
                    </p>
                    <p className="mb-2">
                      <strong className="text-purple">Phone: </strong> {""}
                      {leadDetail?.person_details
                        ? JSON.parse(leadDetail?.person_details)[0]
                          ?.person_phone
                          ? JSON.parse(leadDetail?.person_details)[0]
                            .person_phone
                          : leadDetail?.phonenumber != null
                            ? leadDetail?.phonenumber
                            : "-"
                        : leadDetail?.phonenumber != null
                          ? leadDetail?.phonenumber
                          : "-"}
                    </p> */}

                    <p className="mb-2">
                      <strong className="text-purple">Name:</strong>{" "}
                      {person?.person_name || "-"}
                    </p>

                    <p className="mb-2">
                      <strong className="text-purple">Email:</strong>{" "}
                      {leadDetail?.email || "-"}
                    </p>

                    <p className="mb-2">
                      <strong className="text-purple">Phone:</strong>{" "}
                      {person?.person_phone || leadDetail?.phonenumber || "-"}
                    </p>

                    {/* <p className="mb-2">
                      <strong className="text-purple">id:</strong> {""}
                      {leadDetail.id}
                    </p> */}
                  </div>
                </div>
                <p className="mb-2 me-3">
                  <span className="text-purple fw-bold">Status</span> :
                  {leadDetail?.sname}
                </p>
              </div>
              <div className="mt-4">
                <div className="d-flex gap-4 mt-3">
                  <div className="text-muted">
                    <p>
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>
                      <span className="text-purple fw-bold">Assigned to</span> :
                      {leadDetail?.asigned}
                    </p>
                    <p>
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>
                      <span className="text-purple fw-bold">Industry</span> :
                      {leadDetail?.industry_name}
                    </p>
                    <p>
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>
                      <span className="text-purple fw-bold">
                        Lead Belong To
                      </span>{" "}
                      : {leadDetail.country}
                    </p>
                    <p>
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>
                      <span className="text-purple fw-bold">Source</span> :
                      {leadDetail.source}
                    </p>
                    <p>
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>
                      <span className="text-purple fw-bold">Lead Type</span> :
                      {leadDetail.lead_type}
                    </p>
                    <p>
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>
                      <span className="text-purple fw-bold">
                        Lead Communicator
                      </span>{" "}
                      :
                      {
                        comunicator?.find(
                          (obj) => obj?.member_id == leadDetail?.caller,
                        )?.member_name
                      }
                    </p>
                  </div>
                  <div className="info_box_1"></div>
                  <div className="text-muted">
                    <p>
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>
                      <span className="text-purple fw-bold">Country</span> :
                      {leadDetail?.country}
                    </p>
                    <p>
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>
                      <span className="text-purple fw-bold">State</span> :
                      {leadDetail?.state_name}
                    </p>
                    <p>
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>
                      <span className="text-purple fw-bold">City</span> :
                      {leadDetail?.city}
                    </p>
                    <p>
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>
                      <span className="text-purple fw-bold">Pin</span> :
                      {leadDetail?.zip}
                    </p>
                    <p className="">
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>
                      <strong className="text-purple">Address:</strong>{" "}
                      {leadDetail.address}
                    </p>
                    <p>
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>
                      <span className="text-purple fw-bold">Website</span> :
                      {leadDetail.website}
                    </p>

                    <p className="mb-0">
                      <i className="mdi mdi-chevron-right text-primary me-1"></i>
                      <span className="text-purple fw-bold">Service</span> :
                      {leadDetail.service}
                    </p>
                  </div>
                </div>

                <p className="mt-3">
                  <i className="mdi mdi-chevron-right text-primary me-1"></i>
                  <strong className="text-purple">Description:</strong>{" "}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: leadDetail?.description,
                    }}
                  ></span>
                </p>
              </div>
            </div>
            <div className="col-md-5">
              <form onSubmit={onActionNewLead}>
                <Row className="align-items-center justify-content-between">
                  <div className="col-12 d-flex justify-content-between">
                    <h5 className="text-dark">Add New Note</h5>
                    <div className="text-end me-3 align-items-center d-flex">
                      <Label htmlFor="formrow-firstname-Input">
                        Assign Task
                      </Label>
                      <div className="form-switch form-switch-md mb-2 mt-1">
                        <input
                          title="Intial Days"
                          type="checkbox"
                          className="form-check-input"
                          id="customSwitchsizemd"
                          value={isNote}
                          onChange={(e) => setIsNote(e.target.checked)}
                        />
                      </div>
                    </div>
                  </div>
                  {isNote ? (
                    <div className="d-flex gap-2 flex-wrap">
                      <div className="col-12 mb-3">
                        <label htmlFor="">
                          Enter Task Name <span className="text-danger">*</span>
                        </label>
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Enter Task Name"
                          value={taskName}
                          onChange={(e) => setTaskName(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-4 d-flex flex-column text-start  flex-wrap mb-3">
                        <label htmlFor="">
                          Assignee <span className="text-danger">*</span>
                        </label>
                        <ReactSelect
                          placeholder="Select Assignee"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={alldependency?.users}
                          value={assignee}
                          onChange={(e) => setAssignee(e)}
                        />
                      </div>
                      <div className="col-4 mb-3">
                        <label htmlFor="">
                          Priority <span className="text-danger">*</span>
                        </label>
                        <ReactSelect
                          placeholder="Select Task"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={priorityOption}
                          value={priority}
                          onChange={(e) => setPriority(e)}
                        />
                      </div>
                    </div>
                  ) : null}
                  <div className="" style={{ width: "98%" }}>
                    <label htmlFor="">Description</label>
                    <div className="no-drag">
                      <CKEditor
                        editor={ClassicEditor}
                        data={noteDescription || ""}
                        onReady={(editor) => {}}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setNoteDescription(data);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="">Attachment</label>
                    <Dropzone
                      onDrop={(acceptedFiles) => {
                        handleAcceptedFiles1(acceptedFiles);
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div
                          className="dz-message needsclick p-0"
                          {...getRootProps()}
                        >
                          <input {...getInputProps()} />
                          <div className="d-flex px-2 custom-file-upload align-items-center">
                            <div className="">
                              <i className="display-6 text-muted bx bxs-cloud-upload" />
                            </div>
                            <h5 className="mb-0 ms-2">Upload Files</h5>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                  </div>
                  <div
                    className={`col-md-5 mt-3 dropzone-previews ${
                      selectedFiles1.length > 0 ? "d-block" : "d-none"
                    }`}
                    id="file-previews"
                  >
                    <label className="mb-1">Uploaded Files</label>
                    <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                      <div className="p-1">
                        <Row className="align-items-center justify-content-evenly">
                          {selectedFiles1.map((f, i) => {
                            return (
                              <Col key={i} className="col-auto">
                                <img
                                  data-dz-thumbnail=""
                                  height="80"
                                  className="avatar-sm rounded bg-light"
                                  alt={f.name}
                                  src={f.preview}
                                />
                              </Col>
                            );
                          })}
                        </Row>
                      </div>
                    </Card>
                  </div>
                  <div className="text-end mt-3">
                    <button className="btn btn-save  me-2 btn-label">
                      <i className="fas fa-plus me-2 label-icon"></i>Add Note
                    </button>
                  </div>
                </Row>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
});

const GeneralTask = ({ closeActivities }) => {
  const [fixButtons, setFixButtons] = useState(false);
  const [addGeneralTask, setAddGeneralTask] = useState(false);
  const [editGeneralTask, setEditGeneralTask] = useState(false);
  const [planedDay, setPlanedDay] = useState(false);
  const [noDrag, setNoDrag] = useState();
  const [boxWidth, setBoxWidth] = useState(0);
  const [boxHeight, setBoxHeight] = useState(0);
  const [fixedSideTab, setFixedSideTab] = useState(false);
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [generalData, setGeneratData] = useState({});
  const [timeToken, setTimeToken] = useState(null);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const roles = useSelector((state) => state?.Roles?.apiData);
  const [mainAllData, setMainAllData] = useState([]);
  const [notes, setNotes] = useState("");
  const [relatedTo, setRelatedTo] = useState("");
  const [relatedId, setRelatedId] = useState("");
  const [isNote, setIsNote] = useState(false);
  const [isFollowUp, setIsFollowUp] = useState(true);
  const [editTime, setEditTime] = useState(false);
  const [timeId, setTimeId] = useState("");
  const [copyNote, setCopyNote] = useState(true);
  const [tenderTaskModal, setTenderTaskModal] = useState(false);
  const [tenderData, setTenderData] = useState({});
  const [type, setType] = useState("task");

  const [selectedPlanedTask, setSelectedPlanedTask] = useState("Td");
  const [isClosedDay, setIsClosedDay] = useState(false);
  const [selectedDateforbtn, setSelectedDateForBtn] = useState(
    moment().format("YYYY-MM-DD"),
  );
  const [isAllowed, setIsAllowed] = useState(false);
  const token = secureLocalStorage.getItem("auth_token");
  const auth_user_id = Number(localStorage.getItem("auth_id"));

  const [showNotesPopup, setShowNotesPopup] = useState(false);
  const [notesLeadId, setNotesLeadId] = useState(null);
  // True only when the popup was opened via "Complete + Next Followup" —
  // the Notes popup then lands directly on the Add Follow-up form.
  const [nextFollowupMode, setNextFollowupMode] = useState(false);
  const [note_data, setNoteData] = useState([]);
  const [assigned_data, setAssignData] = useState([]);
  const [subtasks, setSubtasks] = useState([]);

  const [submittedRfpStep, setSubmittedRfpStep] = useState("");

  const fetchDashboardRfp = async () => {
    setLoading(true);

    try {
      const userId = localStorage.getItem("auth_id");

      const res = await axios.get(
        `${configure.nodeApi}/rfp_dashboard/${userId}`,
      );

      if (res.data.success) {
        setSubmittedRfpStep(res.data.data);
      }
    } catch (error) {
      console.error("Dashboard fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardRfp();
  }, []);

  document.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      setFixButtons(true);
    } else {
      setFixButtons(false);
    }
  });

  // Draggabled popop issue
  const [position, setPosition] = useState({ top: "10%", left: "50%" });
  const [currentFollowupId, setCurrentFollowupId] = useState(null);

  useEffect(() => {
    const updatePopupPosition = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      const popupWidth = 1732.8; // Adjust based on your requirement
      const popupHeight = 500; // Adjust this if needed

      const newTop = (height - popupHeight) / 2;
      const newLeft = (width - popupWidth) / 2;

      setPosition({ top: `${newTop}px`, left: `${newLeft}px` });
    };

    // Update position on window resize
    window.addEventListener("resize", updatePopupPosition);

    // Set initial position
    updatePopupPosition();

    return () => {
      window.removeEventListener("resize", updatePopupPosition);
    };
  }, []);

  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth;
      setBoxWidth(viewportWidth * 0.85);
    };
    const updateHeight = () => {
      const viewportHeight = window.innerHeight;
      setBoxHeight(viewportHeight * 0.95);
    };

    updateHeight();
    updateWidth();
    window.addEventListener("resize", updateWidth, updateHeight);
    return () =>
      window.removeEventListener("resize", updateWidth, updateHeight);
  }, []);

  const [modalType, setModalType] = useState("");
  const [timesData, setTimesData] = useState([]);
  const [taskId, setTaskId] = useState("");
  const [addHours, setAddHours] = useState(false);
  const [updateTodayData, setUpdateTodayData] = useState(false);
  const updateTodayDataRef = useRef(false);
  const setUpdateFlag = (val) => {
    updateTodayDataRef.current = val;
    setUpdateTodayData(val);
  };

  const handleEditTask = (obj, type) => {
    setEditGeneralTask(true);
    setGeneratData(obj);
    setModalType(type);
  };

  const [modal_Access, setAccessDenied] = useState(false);

  const onDelete = async (id) => {
    const permission = checkPermissionsByModule(roles, 8, 5);
    if (permission) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete this activity !",
        icon: "warning",
        showCancelButton: true,
      }).then(async (willDelete) => {
        if (willDelete.isConfirmed) {
          const formEntities = {
            user_id: localStorage.getItem("auth_id"),
            general_id: id,
            type: 2,
          };
          const response = await FetchNodePostData(
            toggleLoading,
            "deleteGeneralTasks",
            secureLocalStorage?.getItem("auth_token"),
            formEntities,
          );
          if (response?.data?.success) {
            Swal.fire({
              icon: "success",
              text: "Activity deleted successfully.",
            }).then(async () => {
              updateData(response?.data?.data?.tasks[0], "delete");

              if (updateTodayDataRef.current) {
                const response = await plannedDayData(
                  memberId || localStorage.getItem("auth_id"),
                  planDate || new Date(),
                  toggleLoading,
                );
                if (response != false) {
                  storePlanedDayData(response);
                }
              }
            });
          }
        }
      });
    } else {
      setAccessDenied(true);
    }
  };

  const handleChangeStatus = async (
    e,
    id,
    relatedTo,
    relatedId,
    status,
    personal,
    taskData,
  ) => {
    const formDatas = {
      user_id: localStorage.getItem("auth_id"),
      role_id: secureLocalStorage.getItem("auth_role"),
      general_id: id,
      relatedTo: relatedTo,
      status: status == "complete" ? "mark-completed" : e.target.value,
      type: 2,
    };
    const response = await FetchNodePostData(
      toggleLoading,
      "changeGeneralTaskStatus",
      secureLocalStorage?.getItem("auth_token"),
      formDatas,
    );
    if (response?.data.success) {
      Swal.fire({
        icon: "success",
        title: "Status has been changed successfully!",
      }).then(async () => {
        if (updateTodayDataRef.current) {
          const response = await plannedDayData(
            memberId || localStorage.getItem("auth_id"),
            planDate || new Date(),
            toggleLoading,
          );
          if (response != false) {
            storePlanedDayData(response);
          }
        }

        if (e.target.value == "complete") {
          updateData(response?.data?.data?.tasks[0], "edit");

          if (
            personal == false ||
            (personal && taskData?.status != "mark-completed")
          ) {
            handleAddHour(id, relatedTo, relatedId, taskData);
          }
        }
      });
    }
  };

  const onManagePlan = async (id, status, type) => {
    const formDatas = {
      user_id: localStorage.getItem("auth_id"),
      role_id: secureLocalStorage.getItem("auth_role"),
      task_id: id,
      status: status,
      type: type,
    };
    const applyPlanDay = (item) =>
      item.id == id && item.type == type
        ? { ...item, plan_day: status }
        : item;
    setMainAllData((prev) => prev?.map(applyPlanDay));
    setAllData((prev) => prev?.map(applyPlanDay));
    setData((prev) => prev?.map(applyPlanDay));

    await FetchNodePostData(
      toggleLoading,
      "manageDayPlan",
      secureLocalStorage?.getItem("auth_token"),
      formDatas,
    );
  };

  const [totalData, setRowData] = useState();
  const handleAddHour = async (id, related_To, related_Id, rowData) => {
    setRowData(rowData);
    const response = await fetchNodeData(
      toggleLoading,
      `timeUpdateData/${id}`,
      secureLocalStorage.getItem("auth_token"),
    );
    if (response?.success) {
      setTimesData(response?.data);
    }
    setAddHours(true);
    setTaskId(id);
    setRelatedTo(related_To);
    setRelatedId(related_Id);
  };

  const handleTimeToken = async (e) => {
    e.preventDefault();
    if (timeToken !== null && notes?.length != 0) {
      const formDatas = {
        user_id: localStorage.getItem("auth_id"),
        task_id: taskId,
        time: timeToken?.value,
        type: 2,
        note: notes,
        related_id: relatedId,
        related_to: relatedTo,
        copynotes: isNote,
        timeid: editTime ? timeId : "",
        date: selectedDate,
      };
      const response = await FetchPostData(
        toggleLoading,
        `${editTime ? "editTimeUpdate" : "timeUpdate"}`,
        secureLocalStorage?.getItem("auth_token"),
        formDatas,
      );
      if (response?.data?.success) {
        if (updateTodayDataRef.current) {
          const date = selectedDate
            ? new Date(selectedDate)
            : planDate
            ? new Date(planDate)
            : new Date();
          const refreshed = await plannedDayData(
            memberId || localStorage.getItem("auth_id"),
            date,
            toggleLoading,
          );
          if (refreshed) {
            storePlanedDayData(refreshed);
          }
        }
        setNotes("");

        setLoading(false);
        setTimeToken(null);
        setTimesData(response?.data?.data?.times);

        // if its personal tab
        if (tabType && type == "task") {
          const token = secureLocalStorage.getItem("auth_token");
          const userId = localStorage.getItem("auth_id");

          (async () => {
            const res = await fetchNodeData(
              toggleLoading,
              `personaltasks/${userId}`,
              token,
            );
            if (res) {
              const tasks = res?.tasks?.map((obj) => ({
                ...obj,
                type: 1,
              }));
              setData(tasks);
              setAllData(tasks);
            }
          })();
        } else {
          updateData(response?.data?.data?.tasks?.tasks[0], "edit");
        }
        Swal.fire({
          icon: "success",
          text: `Time ${editTime ? "updated" : "added"} successfully.`,
        });
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: "Please add mendatory fields",
      });
    }
  };

  const fetchLeadData = async (id) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("lead_id", id);
    formData.append("user_id", localStorage.getItem("auth_id"));
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/all_lead_data`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).then((response) => {
        setNoteData(response.data.data?.lead_note);
        setAllFollowups(response.data.data?.lead_followup_data || []);
        setAssignData(response.data.data?.assigned || []);
        setLoading(false);
      });
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  // Shared "complete follow-up" API call (type 1 = My Activity flow).
  const completeFollowupApi = async ({ user_id, followup_id, type = 1 }) => {
    const formEntities = {
      user_id: user_id,
      followup_id: followup_id,
      type: type,
    };
    return await FetchNodePostData(
      toggleLoading,
      "followup_status",
      secureLocalStorage?.getItem("auth_token"),
      formEntities,
    );
  };

  // Refresh today's plan report after a completion, when the plan view
  // is tracking changes (same block previously duplicated inline).
  const refreshDayPlanReport = async () => {
    if (updateTodayData) {
      const formDatas = {
        user_id: localStorage.getItem("auth_id"),
        role_id: secureLocalStorage.getItem("auth_role"),
        type: 2,
      };
      const response = await FetchPostData(
        toggleLoading,
        "dayPlanReport",
        secureLocalStorage?.getItem("auth_token"),
        formDatas,
      );
      if (response?.data?.success) {
        storePlanedDayData(response.data.data);
      }
    }
  };

  // Open the Lead Notes popup so the user can add the next follow-up.
  const openNextFollowupPopup = async (lead_id, followup_id) => {
    setNotesLeadId(lead_id);
    await fetchLeadData(lead_id);
    localStorage.setItem(
      "notes_pending_session",
      JSON.stringify({
        lead_id: lead_id,
        followup_id: followup_id,
        openedAt: new Date().toISOString(),
      }),
    );
    setNextFollowupMode(true);
    setShowNotesPopup(true);
  };

  // Fired by the Notes popup after the next follow-up is added and the
  // user confirms the success message — session complete, close popup.
  const handleNextFollowupAdded = () => {
    localStorage.removeItem("notes_pending_session");
    setNextFollowupMode(false);
    setShowNotesPopup(false);
  };

  const followChangeStatus = async ({ user_id, followup_id, lead_id }) => {
    const permission = checkPermissionsByModule(roles, 17, 1);
    if (!permission) {
      setAccessDenied(true);
      return;
    }

    // Paths without a lead (e.g. Plan My Day) keep the old single-confirm
    // flow — the 2-option flow below is main-table only.
    if (!lead_id) {
      Swal.fire({
        title: "Are You sure ?",
        text: "The follow-up is completed.",
        icon: "warning",
        showCancelButton: true,
      }).then(async (willOkay) => {
        if (willOkay.isConfirmed) {
          const response = await completeFollowupApi({
            user_id: user_id,
            followup_id: followup_id,
            type: 1,
          });
          if (response?.data?.success) {
            setLoading(false);
            updateData({ id: followup_id }, "followup_status");
            Swal.fire({
              text: "FollowUp is completed.",
              icon: "success",
            });
            await refreshDayPlanReport();
          } else {
            setLoading(false);
          }
        }
      });
      return;
    }

    // Main table: single dialog with 2 completion choices.
    const choice = await Swal.fire({
      title: "Complete Follow-up?",
      text: "Choose how to complete this follow-up.",
      icon: "warning",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Complete + Next Followup",
      denyButtonText: "Just Complete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#762C99",
    });

    if (choice.isConfirmed) {
      // Complete + next followup: complete, drop the row, open Notes popup.
      const response = await completeFollowupApi({
        user_id: user_id,
        followup_id: followup_id,
        type: 1,
      });
      if (response?.data?.success) {
        setLoading(false);
        updateData({ id: followup_id }, "followup_status");
        await openNextFollowupPopup(lead_id, followup_id);
        await refreshDayPlanReport();
      } else {
        setLoading(false);
      }
    } else if (choice.isDenied) {
      // Just complete: complete, drop the row, success toast only.
      const response = await completeFollowupApi({
        user_id: user_id,
        followup_id: followup_id,
        type: 1,
      });
      if (response?.data?.success) {
        setLoading(false);
        updateData({ id: followup_id }, "followup_status");
        localStorage.removeItem("notes_pending_session");
        Swal.fire({
          text: "Follow-up completed.",
          icon: "success",
        });
        await refreshDayPlanReport();
      } else {
        setLoading(false);
      }
    }
    // Cancel/dismiss: do nothing.
  };

  const [leadId, setLeadId] = useState("");
  const [addTaskPopup, setAddTaskPopup] = useState(false);
  const [assigned, setAssigned] = useState(null);
  const [priority, setPriority] = useState(null);
  const [taskName, setTaskName] = useState(null);
  const [tabType, setTabType] = useState(false);

  const onAddTask = (id, followupId) => {
    FetchNotes(id);
    setLeadId(id);
    setCurrentFollowupId(followupId);
  };

  const handleApprove = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Approve this activity !",
      icon: "warning",
      showCancelButton: true,
    }).then(async (willDelete) => {
      if (willDelete.isConfirmed) {
        const formEntries = {
          contract_id: id,
        };
        const response = await FetchPostData(
          toggleLoading,
          "approveContract",
          secureLocalStorage.getItem("auth_token"),
          formEntries,
        );
        if (response?.data?.success) {
          Swal.fire({
            icon: "success",
            text: "Contract Approved successfully.",
          }).then(() => {
            setData(
              response?.data?.data?.original?.data?.map((obj) => ({
                ...obj,
                type: 3,
              })),
            );
          });
        }
      }
    });
  };

  const columns = useMemo(
    () =>
      generalDashboardColumns(
        handleEditTask,
        onDelete,
        handleChangeStatus,
        onManagePlan,
        handleAddHour,
        followChangeStatus,
        onAddTask,
        handleApprove,
      ),
    [data],
  );

  const [isIndex, setIsIndex] = useState(false);
  const [verticalActiveTab, setverticalActiveTab] = useState("1");
  const [isLoading, setLoading] = useState(true);
  const [alldependency, setAllDependency] = useState({});
  const [tasks, setTask] = useState([]);
  const [taskDepends, setTaskDepends] = useState(null);
  const [plannedData, setPlanedDayData] = useState({});
  const [copynotes, setCopyNotes] = useState(false);

  const [rfpLevelUsers, setRfpLevelUsers] = useState([]);

  const toggleVertical = (tab) => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab);
    }
  };

  const handleHover = () => {
    setIsIndex(true);
  };

  const handleLeave = () => {
    setIsIndex(false);
  };

  const toggleLoading = (loading) => {
    setLoading(loading);
  };
  const dispatch = useDispatch();

  const fetchAllData = async () => {
    const authToken = secureLocalStorage.getItem("auth_token");
    const datas = await fetchNodeData(false, "generalData", authToken);
    setAllDependency(transformGeneralData(datas?.data));
    dispatch(setGeneralData(transformGeneralData(datas?.data)));
    setTask(
      datas?.data?.subtasks?.map((obj) => ({
        id: obj.task,
        related: obj.related,
        subtasks: obj.subtasks,
        value: obj.task,
        label: obj.task,
      })),
    );
    // setType("task")
  };

  const FetchTasks = async (data_type = 1, status_type = null) => {
    const formDataEntries = {
      role_id: secureLocalStorage.getItem("auth_role"),
      user_id: localStorage.getItem("auth_id"),
      type: 2,
      data_type,
    };

    const datas = await FetchNodePostData(
      toggleLoading,
      "/generalTasks",
      "",
      formDataEntries,
    );

    if (datas?.data?.success) {
      const tasks =
        datas?.data?.data?.tasks?.map((obj) => ({
          ...obj,
          type: 1,
        })) || [];

      const follows =
        datas?.data?.data?.followup?.map((obj) => ({
          ...obj,
          tab_type: 0,
          type: 2,
        })) || [];

      console.log(tasks);

      // ✅ Decide new incoming data based on type
      const incomingData = data_type === 1 ? tasks : follows;

      // ✅ Keep previous opposite type data
      const prevData = mainAllData || [];
      const filteredPrev = prevData.filter((item) => item.type !== data_type);

      // ✅ Merge old + new
      const mergedData = [...filteredPrev, ...incomingData];

      // ✅ Apply common filter
      const filterData = mergedData.filter(
        (obj) =>
          obj?.status !== "complete" &&
          obj?.status !== "mark-completed" &&
          obj?.tab_type == 0,
      );

      // ✅ Update states
      setAllData(filterData);
      setMainAllData(filterData);

      // ==========================
      // TAB FILTERING
      // ==========================
      switch (status_type || type) {
        case "task":
          setData(filterData.filter((obj) => obj?.type == 1));
          break;

        case "follow":
          setData(filterData.filter((obj) => obj?.type == 2));
          break;

        case "new":
          setData(filterData.filter((obj) => obj?.enddate == null));
          break;

        case "assigned":
          setData(
            filterData.filter(
              (item) =>
                item.type == 1 &&
                item.added_by != localStorage.getItem("auth_id"),
            ),
          );
          break;

        default:
          setData(filterData.filter((obj) => obj?.type == 1));
      }
    }
  };

  useEffect(() => {
    fetchAllData();
    FetchTasks();

    // Fetch RFP role permissions to check level access
    axios
      .get(`${configure.nodeApi}/rfp_permissions_all`, {
        headers: { Accept: "application/json" },
      })
      .then((res) => {
        if (res.data.success) setRfpLevelUsers(res.data.data);
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    const checkPendingSession = async () => {
      const raw = localStorage.getItem("notes_pending_session");
      if (!raw) return;

      const session = JSON.parse(raw);
      const minutesAgo = (new Date() - new Date(session.openedAt)) / 1000 / 60;

      if (minutesAgo > 1440) {
        localStorage.removeItem("notes_pending_session");
        return;
      }

      const result = await Swal.fire({
        icon: "warning",
        title: "Incomplete Follow-Up Session",
        html: `You completed a follow-up <b>${moment(
          session.openedAt,
        ).fromNow()}</b> but didn't add a note.<br/><br/>Would you like to open the notes for that lead now?`,
        showCancelButton: true,
        confirmButtonText: "Yes, Open Notes",
        cancelButtonText: "Dismiss",
        confirmButtonColor: "#762C99",
      });

      if (result.isConfirmed) {
        setNotesLeadId(session.lead_id);
        await fetchLeadData(session.lead_id);
        setShowNotesPopup(true);
      } else {
        localStorage.removeItem("notes_pending_session");
      }
    };
    setTimeout(checkPendingSession, 1500);
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (showNotesPopup) {
        e.preventDefault();
        e.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [showNotesPopup]);

  const onCloseAddModal = () => {
    setAddGeneralTask(false);
  };
  const onCloseEditModal = () => {
    setEditGeneralTask(false);
  };
  const onChangeDrag = (drag) => {
    setNoDrag(drag);
  };

  const updateData = (data, alterType) => {
    // if its personal tab
    if (tabType && (type == "task" || type == "assigned")) {
      const token = secureLocalStorage.getItem("auth_token");
      const userId = localStorage.getItem("auth_id");

      (async () => {
        const res = await fetchNodeData(
          toggleLoading,
          `personaltasks/${userId}`,
          token,
        );
        if (res) {
          const tasks = res?.tasks?.map((obj) => ({
            ...obj,
            type: 1,
          }));
          if (type == "assigned")
            setData(
              tasks?.filter(
                (item) => item.added_by != localStorage.getItem("auth_id"),
              ),
            );
          else setData(tasks);

          setAllData(tasks);
        }
      })();
      return;
    }

    let mergedData = [];

    switch (alterType) {
      case "add":
        mergedData = [...mainAllData, { type: 1, ...data }];
        break;
      case "edit":
        mergedData = [...mainAllData].map((item) => {
          if (item.type == 1 && item.id == data.id) {
            return {
              ...data,
              type: 1,
            };
          } else {
            return item;
          }
        });
        break;
      case "delete":
        mergedData = [...mainAllData].filter(
          (item) => (item.type == 1 && item.id != data.id) || item.type == 2,
        );
        break;

      case "followup_status":
        mergedData = [...mainAllData].filter(
          (item) => (item.type == 2 && item.id != data.id) || item.type == 1,
        );
        break;

      default:
        mergedData = [...mainAllData];
    }

    const filterData = mergedData?.filter(
      (obj) =>
        obj?.status != "complete" &&
        obj?.status != "mark-completed" &&
        (tabType ? obj?.tab_type == 1 : obj?.tab_type == 0),
    );
    // setData(filterData)
    setAllData(filterData);
    setMainAllData(
      mergedData?.filter(
        (obj) =>
          obj?.status != "complete" &&
          obj?.status != "mark-completed" &&
          obj?.tab_type == 0,
      ),
    );

    switch (type) {
      case "task":
        setData(filterData?.filter((obj) => obj?.type == 1));
        break;
      case "follow":
        setData(filterData?.filter((obj) => obj?.type == 2));
        break;
      case "new":
        setData(filterData?.filter((obj) => obj?.enddate == null));
        break;
      case "assigned":
        setData(
          filterData?.filter(
            (item) =>
              item.type == 1 &&
              item.added_by != localStorage.getItem("auth_id"),
          ),
        );
        break;
      default:
        setData(filterData?.filter((obj) => obj?.type == 1));
    }
  };

  const storePlanedDayData = (data) => {
    setPlanedDayData(data);
  };

  const modalRef = useRef(null);
  const onEditTask = (obj, type) => {
    setEditGeneralTask(true);
    setGeneratData(obj);
    setModalType(type);
    setUpdateFlag(true);
  };
  const onDeleteTask = (id) => {
    setUpdateFlag(true);
    onDelete(id);
  };
  const handleStatus = (
    e,
    id,
    related_To,
    related_Id,
    status,
    personal,
    taskData,
  ) => {
    setUpdateFlag(true);
    handleChangeStatus(
      e,
      id,
      related_To,
      related_Id,
      status,
      personal,
      taskData,
    );
  };

  const FollowupStatus = ({ user_id, followup_id }) => {
    setUpdateFlag(true);
    followChangeStatus({ user_id, followup_id });
  };
  const [changePopup, setChangePopup] = useState(false);
  const onAddHours = (id, related_To, related_Id) => {
    setChangePopup(true);
    setUpdateFlag(true);
    handleAddHour(id, related_To, related_Id);
  };
  const onFollowTask = (id) => {
    FetchNotes(id);
    // setAddTaskPopup(true)
    setLeadId(id);
  };
  const [planDate, setPlanDate] = useState(
    moment(new Date()).format("YYYY-MM-DD"),
  );
  const [memberId, setMemberId] = useState("");
  const [members, setMembers] = useState([]);
  const onOpenTodayPlan = async (type) => {
    const userId = localStorage.getItem("auth_id");
    const res = await plannedDayData(
      type == "clear" ? userId : memberId,
      planDate,
      toggleLoading,
    );
    if (res != false) {
      setPlanedDayData(res);
      setPlanedDay(true);
    }
  };
  const onGetMember = (option) => {
    setMembers(option);
  };

  const onGetTabType = (type) => {
    setTabType(type);
  };

  const [assignee, setAssignee] = useState([]);
  const [noteDescription, setNoteDescription] = useState("");
  const [selectedFiles1, setselectedFiles1] = useState([]);
  // follow up
  const [assignes, setAssignes] = useState([]);
  const [followdate, setFollowdate] = useState("");
  const [followdescription, setFollowDescription] = useState("");

  function handleAcceptedFiles1(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );
    setselectedFiles1(files);
  }

  const markFollowupComplete = async (followupId) => {
    if (!followupId) return;
    const formEntities = {
      user_id: localStorage.getItem("auth_id"),
      followup_id: followupId,
      type: 2,
    };
    await FetchPostData(
      toggleLoading,
      "followup_status",
      secureLocalStorage.getItem("auth_token"),
      formEntities,
    );
  };

  const onActionNewLead = async (e) => {
    e.preventDefault();
    if (noteDescription != "") {
      if (isNote || isFollowUp) {
        // if (isNote) {
        toggleLoading(true);
        const result = assignes?.map((obj) => obj.value).join(",");
        const formData = new FormData();

        formData.append("assign_user", result);
        formData.append("follow_date", followdate);
        formData.append("follow_description", followdescription);
        formData.append("isFollowUp", isFollowUp ? 1 : 0);

        formData.append("user_id", localStorage.getItem("auth_id"));
        if (taskName) formData.append("title", taskName);
        if (assignee?.value) formData.append("assigned", assignee?.value);
        if (priority?.value) formData.append("priority", priority?.value);
        formData.append("related", "sales");
        formData.append("related_to", "lead");
        formData.append("related_id", leadId);
        formData.append("description", noteDescription);
        formData.append("type", 2);
        formData.append("copynotes", true);
        for (let i = 0; i < selectedFiles1.length; i++) {
          formData.append("files[]", selectedFiles1[i]);
        }

        const response = await FetchNodePostData(
          toggleLoading,
          "addGeneralTasks",
          secureLocalStorage.getItem("auth_token"),
          formData,
        );
        if (response?.data?.success) {
          await markFollowupComplete(currentFollowupId);

          Swal.fire({
            icon: "success",
            text: "Data Saved Successfully.",
          }).then(() => {
            setAddTaskPopup(false);
            setFollowdate("");
            setAssignes([]);
            setFollowDescription("");
            setNoteDescription("");
            setselectedFiles1([]);

            setTaskName("");
            setAssignee({});
          });
          toggleLoading(false);
        }
      } else {
        toggleLoading(true);
        const formData = new FormData();
        formData.append("lead_id", leadId);
        formData.append("user_id", localStorage.getItem("auth_id"));
        formData.append("description", noteDescription);
        for (let i = 0; i < selectedFiles1.length; i++) {
          formData.append("files[]", selectedFiles1[i]);
        }
        try {
          const response = await axios({
            method: "post",
            url: `${configure.nodeApi}/add_lead_note`,
            data: formData,
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          }).then((response) => {
            toggleLoading(false);
            Swal.fire({
              icon: "success",
              text: "Note Added  Successfully.",
            }).then(() => {
              setAddTaskPopup(false);
              setNoteDescription("");
              setselectedFiles1([]);
            });
          });
        } catch (error) {
          console.log(error);
          toggleLoading(false);
        }
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: "Please add a note description.",
      });
    }
  };

  const [allNotes, setAllNotes] = useState([]);
  const [followLeadData, setFollowLeadData] = useState({});

  const [allFollowups, setAllFollowups] = useState([]);
  const [activeNoteTab, setActiveNoteTab] = useState("notes");

  const FetchNotes = async (id) => {
    setLoading(true);
    const response = await axios({
      method: "get",
      url: `${configure.nodeApi}/leadNotesData/${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    if (response?.data?.status) {
      // setCurrencyOption(
      //   response?.data?.data.currency.map(item => ({
      //     label: item.currency,
      //     value: item.id,
      //   }))
      // )
      setAddTaskPopup(true);
      setFollowLeadData(response?.data?.data?.leadData || {});
      setAllNotes(response?.data?.data?.notes);

      await fetchLeadData(id);
    } else {
      swal("", "Something went wrong", "error");
    }
    setLoading(false);
  };

  function getPersonName(personName) {
    try {
      const falsyValues = ["", "[]", null, "null", "undefined", undefined];
      if (falsyValues.includes(personName) || !personName) {
        return null;
      }
      return JSON.parse(personName || "[]")[0]?.person_name || null;
    } catch (error) {
      return null;
    }
  }

  const onAddTenderNote = async (e) => {
    e.preventDefault();
    if (noteDescription != "") {
      if (isNote) {
        const formDatas = {
          user_id: localStorage.getItem("auth_id"),
          title: taskName,
          assigned: assignee?.value,
          priority: priority?.value,
          related: "others",
          related_to: "",
          description: noteDescription,
          startDate: new Date(),
          isNote,
          tenderId: tenderData.id,
        };
        const response = await FetchNodePostData(
          toggleLoading,
          "generalTenderTask",
          secureLocalStorage.getItem("auth_token"),
          formDatas,
        );
        if (response?.data?.success) {
          Swal.fire({
            icon: "success",
            text: "Note Added & Task Added Successfully.",
          }).then(() => {
            setTaskName("");
            setAssignee([]);
            setPriority([]);
            setNoteDescription("");
            setIsNote(false);
            setTenderData({});
            setTenderTaskModal(false);
          });
        }
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: "Please add a note description.",
      });
    }
  };

  const date = moment().format("YYYY-MM-DD");
  useEffect(() => {
    getClosedBtnResForBa();
  }, [planedDay]);

  const getClosedBtnResForBa = async () => {
    const res = await fetchNodeData(
      false,
      `pendingTasks/${date}/${auth_user_id}`,
      token,
    );
    setIsClosedDay(Boolean(res?.isClosed));
  };

  const handleCloseDay = async () => {
    try {
      const confirmResult = await Swal.fire({
        title: "Are you sure?",
        text: "You want to close your day!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes! Do it",
        cancelButtonText: "No",
      });

      if (!confirmResult.isConfirmed) return;

      const payload = {
        id: auth_user_id,
        date: moment().format("YYYY-MM-DD"), // always today's date
      };

      const res = await FetchNodePostData(
        setLoading,
        "alltodaysTasks/post",
        token,
        payload,
      );

      if (res.data?.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Day has been Closed",
        });
        // setPlanedDay(false);
        setIsClosedDay(true);
      } else {
        Swal.fire("", "Something went wrong!", "error");
      }
    } catch (error) {
      console.error("Submit pending tasks error:", error);
      Swal.fire("", "Something went wrong!", "error");
    }
  };

  const currentUserId = localStorage.getItem("auth_id");

  const hasRfpAccess = rfpLevelUsers.some(
    (r) =>
      String(r.user_id) === String(currentUserId) &&
      r.level &&
      r.level.trim() !== "",
  );

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="position-relative bg-white">
        <div>
          <Row>
            <Col lg="12">
              <Card>
                <div className="">
                  <TableContainer
                    maincolumns={columns}
                    datas={data}
                    allData={allData}
                    setAddGeneralTask={setAddGeneralTask}
                    setPlanedDay={setPlanedDay}
                    toggleLoading={toggleLoading}
                    storePlanedDayData={storePlanedDayData}
                    setAllData={setAllData}
                    onMemberId={(id) => setMemberId(id)}
                    onGetMember={onGetMember}
                    onGetTabType={onGetTabType}
                    mainAllData={mainAllData}
                    onAddTask={onAddTask}
                    alldependency={alldependency}
                    isLoading={isLoading}
                    onManagePlan={onManagePlan}
                    handleChangeStatus={handleChangeStatus}
                    type={type}
                    setType={setType}
                    setTenderTaskModal={setTenderTaskModal}
                    tenderTaskModal={tenderTaskModal}
                    tenderData={tenderData}
                    setTenderData={setTenderData}
                    closeActivities={closeActivities}
                    FetchTasks={FetchTasks}
                    hasRfpAccess={hasRfpAccess}
                    submittedRfpStep={submittedRfpStep}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </div>

        <Modal
          size="xl"
          isOpen={addGeneralTask}
          toggle={() => {
            tog_fullscreen();
          }}
          className="modal-fullscreen"
        >
          <AddTasks
            alldependency={alldependency}
            tasks={tasks}
            onCloseAddModal={onCloseAddModal}
            onChangeDrag={onChangeDrag}
            toggleLoading={toggleLoading}
            updateData={updateData}
            tabType={tabType}
            isLoading={isLoading}
          />
        </Modal>

        {/* Edit Task Modal */}
        <Modal
          size="xl"
          isOpen={editGeneralTask}
          toggle={() => {
            tog_fullscreen();
          }}
          className="modal-fullscreen"
        >
          <EditTasks
            generalData={generalData}
            tasks={tasks}
            toggleLoading={toggleLoading}
            onChangeDrag={onChangeDrag}
            alldependency={alldependency}
            onCloseEditModal={onCloseEditModal}
            updateData={updateData}
            modalType={modalType}
            isLoading={isLoading}
          />
        </Modal>

        {/* Plan My Day  */}
        <Modal size="xl" isOpen={planedDay} className="modal-fullscreen">
          {isLoading && <Loader />}
          <div className="modal-header mb-0 py-0 px-4 ">
            <h5 className="modal-title mt-0">Plan My Day</h5>
            <div className="my-2  d-flex gap-2 col-4 justify-content-end align-items-center">
              {members?.length != 0 && members != null ? (
                <>
                  <button
                    disabled={isClosedDay}
                    className={`btn text-white me-2 btn-${
                      isClosedDay ? "success" : "primary"
                    } text-uppercase btn-label`}
                    style={{ minWidth: "170px" }}
                    onClick={() => {
                      if (!isClosedDay) {
                        handleCloseDay();
                      }
                    }}
                  >
                    <i className="fa fa-check-circle me-2 icon-center label-icon"></i>
                    {isClosedDay ? "Day Closed" : "Close Your Day"}
                  </button>

                  <div className="col-4 col-md-5">
                    <ReactSelect
                      placeholder="Member"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      options={members}
                      value={memberId}
                      onChange={(e) => {
                        setMemberId(e);
                      }}
                    />
                  </div>
                </>
              ) : null}

              <div>
                <Input
                  type="date"
                  className="form-control"
                  placeholder="Enter Task Name"
                  value={planDate}
                  onChange={(e) => setPlanDate(e.target.value)}
                  max={moment().format("YYYY-MM-DD")} // restrict to today or earlier
                />
              </div>
              <button
                className="btn btn-sm  me-1 bg-purple text-white"
                style={{ borderRadius: "5px" }}
                onClick={() => onOpenTodayPlan()}
              >
                <i className="bi bi-funnel-fill fs-5"></i>
              </button>
              <a
                className="btn btn-sm  me-1 bg-warning text-white"
                style={{ borderRadius: "5px" }}
                onClick={(e) => {
                  setMemberId([]);
                  onOpenTodayPlan("clear");
                }}
              >
                <i className="bi bi-x fs-5"></i>
              </a>
              <button
                type="button"
                className="btn-modal-close"
                onClick={() => {
                  setPlanDate(moment(new Date()).format("YYYY-MM-DD"));
                  setPlanedDay(false);
                  setUpdateFlag(false);
                }}
              >
                <span aria-hidden="true" className="btn-modal-span">
                  ×
                </span>
              </button>
            </div>
          </div>

          <div
            className="d-flex align-items-center justify-content-between"
            style={{ width: "100" }}
          >
            <div className="modal-body pe-0 d-flex ">
              <div
                className={`px-0 col-1 plan-tab ${
                  fixedSideTab && "credtabFix"
                }`}
                style={isIndex ? { zIndex: "2" } : {}}
              >
                <div className="position-relative">
                  <div>
                    <SimpleBar
                      style={{ height: "55vh" }}
                      className={`${fixedSideTab && ""}`}
                    >
                      <Nav
                        pills
                        className={`${
                          fixedSideTab && "credtabFix-ul"
                        }  flex-column px-1 py-1 h-100`}
                      >
                        <NavItem
                          className={classnames({
                            "d-flex flex-column gap-2 mb-2": true,
                            active: verticalActiveTab == "1",
                          })}
                        >
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              "text-start crendential": true,
                              active: verticalActiveTab == "1",
                            })}
                            onClick={() => {
                              toggleVertical("1");
                              setSelectedPlanedTask("Td");
                            }}
                            onMouseEnter={handleHover}
                            onMouseLeave={handleLeave}
                          >
                            Today's Task
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({
                            "d-flex flex-column gap-2 mb-2": true,
                            active: verticalActiveTab == "4",
                          })}
                        >
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              "text-start crendential": true,
                              active: verticalActiveTab == "4",
                            })}
                            onClick={() => {
                              toggleVertical("4");
                              setSelectedPlanedTask("AP");
                            }}
                            onMouseEnter={handleHover}
                            onMouseLeave={handleLeave}
                          >
                            Assigned Projects
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </SimpleBar>
                  </div>
                </div>
              </div>
              <PlanMyDay
                selectedPlanedTask={selectedPlanedTask}
                plannedData={plannedData}
                refData={modalRef}
                onEditTask={onEditTask}
                onDeleteTask={onDeleteTask}
                handleStatus={handleStatus}
                FollowupStatus={FollowupStatus}
                onAddHours={onAddHours}
                onFollowTask={onFollowTask}
                toggleLoading={toggleLoading}
              />
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={addHours}
          toggle={() => {
            tog_fullscreen();
          }}
          style={{
            width: 0,
            position: "fixed",
            top: "5%",
            right: "12%",
            zIndex: "99",
          }}
        >
          <Draggable>
            <ResizableBox
              width={1150}
              style={{
                position: "fixed",
                top: "5%",
                right: "12%",
                zIndex: "9999",
                backgroundColor: "#fff",
                padding: 0,
                boxShadow: "none",
              }}
            >
              {isLoading && <Loader />}
              <div className="modal-header pe-4">
                <h5 className="modal-title mt-0">Time Taken </h5>

                <div>
                  <button
                    onClick={() => {
                      setTaskId("");
                      setAddHours(false);
                      setTimeToken(null);
                      setEditTime(false);
                      setNotes("");
                      setSelectedDate(new Date().toISOString().split("T")[0]);
                    }}
                    className=" btn ms-md-2 btn-red btn-label"
                  >
                    <i className="dripicons-cross me-2 icon-center label-icon"></i>
                    CANCEL
                  </button>
                </div>
              </div>
              <div className="modal-body pe-4">
                <Form
                  onSubmit={handleTimeToken}
                  className="row d-flex justify-content-center"
                >
                  <div
                    className="col-md-6 d-flex ps-3"
                    style={{ flexDirection: "column", height: "100%" }}
                  >
                    <div
                      className="text-start flex-grow-1"
                      style={{
                        overflowY: "auto",
                        maxHeight: "330px",
                        fontSize: "1rem",
                        lineHeight: "2.5",
                      }}
                    >
                      <ul className="list-unstyled mb-0 ">
                        <li style={{ marginBottom: "1rem" }}>
                          <i className="mdi mdi-chevron-right me-2"></i>
                          <strong className="text-purple">
                            Task Name:
                          </strong>{" "}
                          {totalData?.title}
                        </li>

                        <li style={{ marginBottom: "1rem" }}>
                          <i className="mdi mdi-chevron-right me-2"></i>
                          <strong className="text-purple">
                            Estimated Time:
                          </strong>{" "}
                          {totalData?.estimate_time}
                        </li>

                        {/* ✅ Start and End Dates in one row */}
                        <li style={{ marginBottom: "1rem" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            <div style={{ marginRight: "2rem" }}>
                              <i className="mdi mdi-chevron-right me-2"></i>
                              <strong className="text-purple">
                                Start Date:
                              </strong>{" "}
                              {totalData?.startdate &&
                                moment(totalData.startdate).format(
                                  "DD-MM-YYYY",
                                )}
                            </div>
                            <div>
                              <i className="mdi mdi-chevron-right me-2"></i>
                              <strong className="text-purple">
                                End Date:
                              </strong>{" "}
                              {totalData?.enddate &&
                                moment(totalData.enddate).format("DD-MM-YYYY")}
                            </div>
                          </div>
                        </li>

                        <li style={{ marginBottom: "1rem" }}>
                          <i className="mdi mdi-chevron-right me-2"></i>
                          <strong className="text-purple">Description:</strong>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: totalData?.description,
                            }}
                            style={{ marginLeft: "28px" }}
                          />
                        </li>

                        {totalData?.subtasks &&
                          totalData?.subtasks.length > 0 && (
                            <li
                              className="mt-3"
                              style={{ marginBottom: "1rem" }}
                            >
                              <i className="mdi mdi-chevron-right me-2"></i>
                              <strong className="text-purple">Subtasks:</strong>
                              <ul
                                style={{
                                  marginLeft: "28px",
                                  listStyle: "none",
                                }}
                              >
                                {totalData?.subtasks.map((sub, index) => (
                                  <li
                                    key={sub.id}
                                    className="mt-2"
                                    style={{ marginBottom: "1rem" }}
                                  >
                                    <i className="mdi mdi-chevron-right me-2"></i>
                                    <strong>
                                      {index + 1}. {sub?.title}
                                    </strong>
                                    {sub?.description ? (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: sub?.description,
                                        }}
                                        style={{ marginLeft: "28px" }}
                                      />
                                    ) : (
                                      <div style={{ marginLeft: "28px" }}></div>
                                    )}
                                  </li>
                                ))}
                              </ul>
                            </li>
                          )}
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-6 d-flex flex-column justify-content-between gap-5 mb-4">
                    <div className="">
                      <div className="col-12 d-flex justify-content-between align-items-center">
                        <div className="col-6 d-flex gap-1 ">
                          <div className="col-md-6">
                            <label htmlFor="">
                              Select Time <span className="text-danger">*</span>
                            </label>
                            <ReactSelect
                              placeholder="Select Time"
                              className="basic-multi-select"
                              classNamePrefix="select"
                              options={TimeOption}
                              value={timeToken}
                              onChange={(selectedOption) =>
                                setTimeToken(selectedOption)
                              }
                            />
                          </div>
                          <div className="col-md-6 ms-2">
                            <label>
                              Select Date<span className="text-danger">*</span>
                            </label>

                            <input
                              type="date"
                              className="form-control"
                              value={selectedDate}
                              onChange={(e) => setSelectedDate(e.target.value)}
                            />
                          </div>
                          <div className="col-md-4">
                            {relatedId != null ? (
                              <div className="d-flex flex-column">
                                <label>Copy Notes</label>
                                <div className="form-switch form-switch-md mb-2 mt-1">
                                  <input
                                    title="Intial Days"
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customSwitchsizemd"
                                    value={isNote}
                                    onChange={(e) =>
                                      setIsNote(e.target.checked)
                                    }
                                  />
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>

                        <div className="text-end mt-4">
                          <button className=" btn btn-save btn-label">
                            <i className="fas fa-save me-2 label-icon"></i>
                            Save
                          </button>
                          {/* <a
                            onClick={() => {
                              setTaskId("");
                              setAddHours(false);
                              setTimeToken(null);
                              setEditTime(false);
                              setNotes("");
                              setSelectedDate(
                                new Date().toISOString().split("T")[0],
                              );
                            }}
                            className=" btn ms-md-2 btn-red btn-label"
                          >
                            <i className="dripicons-cross me-2 icon-center label-icon"></i>
                            CANCEL
                          </a> */}
                        </div>
                      </div>
                      <div
                        className="mt-3"
                        onDoubleClick={() => setNoDrag(true)}
                        onMouseLeave={() => setNoDrag(false)}
                        onMouseEnter={() => setNoDrag(true)}
                      >
                        <label htmlFor="">
                          Notes <span className="text-danger">*</span>
                        </label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={notes}
                          onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setNotes(data);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Form>
                <div className="table-responsive col-md-12 time-taken-table ms-3">
                  <Table className="table table-bordered mb-0">
                    <thead>
                      <tr>
                        <th className="header time-taken-user">User</th>
                        <th className="text-center header col-1">Date</th>
                        <th className="text-center header col-2">Time Taken</th>
                        <th className="text-center header col-7">Reason</th>
                        <th className="text-center header time-taken-user">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {timesData
                        ?.map((item, i) => {
                          return (
                            <tr key={item.id}>
                              <td>
                                <img
                                  src={`${
                                    item.avatar != null
                                      ? `${configure.imgUrl}${item?.avatar}`
                                      : zithasLogo
                                  }`}
                                  alt=""
                                  className="img-fluid assignee-img"
                                  title={item?.name}
                                />
                              </td>
                              <td className="text-center">
                                {moment(item.created_at).format("DD-MM-YYYY")}
                              </td>
                              <td className="text-center">{item.times}</td>
                              <td className="">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item?.note || "-",
                                  }}
                                />
                              </td>
                              <td className="text-center">
                                <a
                                  className="btn btn-sm btn-outline-secondary me-1"
                                  title="View Activity"
                                  onClick={(e) => {
                                    setTimeId(item?.id);
                                    setEditTime(true);
                                    setNotes(item?.note);
                                    setTimeToken(
                                      TimeOption?.filter(
                                        (obj) => obj.value == item.times,
                                      ),
                                    );
                                  }}
                                >
                                  <i className="fas fa-pen "></i>
                                </a>
                              </td>
                            </tr>
                          );
                        })
                        ?.reverse()}
                      {timesData?.length == 0 && (
                        <tr>
                          <td className="text-center" colSpan={10}>
                            No Data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </ResizableBox>
          </Draggable>
        </Modal>

        {/* <Modal
          size="xl"
          centered
          isOpen={addTaskPopup}
          className="modal-fullscreen"
        >
          <div className="modal-header py-2 justify-content-between align-items-start px-4 pt-4">
            <h5 className="modal-title mt-0">Add Task</h5>

            {type == "follow" ? (
              <>
                <Col className="company-info px-2 mb-3 me-0 d-flex justify-content-center align-items-center">
                  <div className="d-flex justify-content-start align-items-center gap-4">
                    <div>
                      <h5>
                        <i className="bi bi-buildings-fill text-purple"></i>{" "}
                        <span className="border-end border-3 border-dark pe-4 text-primary">
                          {followLeadData?.company || "--"}
                        </span>
                      </h5>
                    </div>

                    <div>
                      <h5>
                        <i className="bi bi-person-fill text-purple"></i>
                        <span className="border-end border-3 border-dark pe-4 text-primary">
                          {" "}
                          {getPersonName(followLeadData?.person_details) ||
                            "--"}
                        </span>{" "}
                      </h5>
                    </div>

                    <div>
                      <h5>
                        <i className="bi bi-telephone-fill text-purple"></i>
                        <span className="border-end border-3 border-dark pe-4 text-primary">
                          {" "}
                          {followLeadData?.phonenumber || "--"}
                        </span>{" "}
                      </h5>
                    </div>

                    <div>
                      <h5>
                        <i className="bi bi-envelope-fill text-purple"></i>{" "}
                        <span className="border-3 border-dark pe-4 text-primary">
                          {" "}
                          {followLeadData?.email || "--"}
                        </span>{" "}
                      </h5>
                    </div>
                  </div>
                </Col>
              </>
            ) : null}

            <div>
              <a
                onClick={() => {
                  setAddTaskPopup(false)
                }}
                className=""
              >
                <i className="dripicons-cross icon-center fs-5 text-dark"></i>
              </a>
            </div>
          </div>
          {type == "follow" ? (
            <div className="px-3 py-2 bg-light rounded-3 mx-4">
              <div className="fw-bold text-dark">Lead Description:</div>
              <div
                style={{
                  maxHeight: "100px",
                  overflow: "auto",
                  scrollbarWidth: "thin",
                }}
                dangerouslySetInnerHTML={{
                  __html: followLeadData?.description || "<div><div/>",
                }}
              />
            </div>
          ) : null}

          <div className="modal-body pe-4">
            <div className="row d-flex justify-content-center align-items-start mt-4">
              <div className="col-md-6 ps-3">
                <h5 className="text-dark">Notes History </h5>
                <div
                  className="mt-4"
                  style={{
                    maxHeight: "75vh",
                    overflowY: "auto",
                    scrollbarWidth: "thin",
                  }}
                >
                  <ul className="verti-timeline list-unstyled notes-box">
                    {allNotes?.map((note, i) => {
                      return (
                        <li className="event-list position-relative" key={i}>
                          <div className="event-timeline-dot connected-dot">
                            {note?.addedby_avatar ? (
                              <img
                                src={`${configure.imgUrl}/${note?.addedby_avatar}`}
                                className="msgUserImg me-3 p-1 bg-light"
                                alt={getInitials(note?.added_by || "Z") || ""}
                              />
                            ) : (
                              <div
                                className="defualt-img event-timeline-dot connected-dot"
                                title={note?.added_by}
                              >
                                {getInitials(note?.added_by || "Z")}
                              </div>
                            )}
                          </div>

                          <div className="d-flex">
                            <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                              <div className="d-flex justify-content-start align-items-center">
                                <div>
                                  <p className="text-muted cursor-pointer">
                                    <h6 className="d-inline me-2">
                                      By {note.added_by}
                                    </h6>

                                    <Tooltip
                                      color="#f0e8f4"
                                      title={
                                        <div className="text-purple fw-bold body-font fs-6">
                                          <div>
                                            UK Time:{" "}
                                            {convertTimeZone(
                                              note.created_at,
                                              "Europe/London",
                                              "DD-MM-YYYY hh:mm:ss a"
                                            )}
                                          </div>

                                          <div>
                                            US Time :{" "}
                                            {moment(note.created_at)
                                              .tz("America/New_York")
                                              .format("DD-MM-YYYY hh:mm:ss a")}
                                          </div>
                                        </div>
                                      }
                                    >
                                      {moment(note.created_at).format(
                                        "DD-MM-YYYY hh:mm:ss"
                                      )}
                                    </Tooltip>

                                    <span className="pl-15">
                                      Got in touch with this lead at{" "}
                                      <Tooltip
                                        color="#f0e8f4"
                                        title={
                                          <div className="text-purple fw-bold body-font fs-6">
                                            <div>
                                              UK Time:{" "}
                                              {convertTimeZone(
                                                note.date,
                                                "Europe/London"
                                              )}
                                            </div>

                                            <div>
                                              US Time :{" "}
                                              {convertTimeZone(
                                                note.date,
                                                "America/New_York",
                                                "DD-MM-YYYY hh:mm:ss a"
                                              )}
                                            </div>
                                          </div>
                                        }
                                      >
                                        {moment(note.date).format(
                                          "DD-MM-YYYY hh:mm a"
                                        )}
                                      </Tooltip>
                                    </span>
                                  </p>
                                </div>
                              </div>

                              <i className="bi bi-triangle-fill note-icon"></i>

                              <div
                                className="Features word-wrap"
                                dangerouslySetInnerHTML={{
                                  __html: note.description,
                                }}
                              />

                              <p className="mb-2">
                                Amount : {note.currency_symbol} {note.amount}{" "}
                              </p>

                              {note.link != null ? (
                                <p className="mb-1">
                                  Attachment :{" "}
                                  <a
                                    target="_blank "
                                    className="btn btn-sm edit-delete-btn text-secondary ml-10"
                                    rel="noreferrer"
                                    type="button"
                                    href={note.link}
                                  >
                                    <i className="fas fa-eye"></i> View
                                  </a>
                                </p>
                              ) : null}
                            </div>
                          </div>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </div>

              <div className="col-md-6 d-flex flex-column justify-space-between  gap-3">
                <Row className="align-items-center justify-content-between">
                  <form onSubmit={e => onActionNewLead(e)}>
                    <div className="col-12 d-flex justify-content-between">
                      <h5 className="text-dark">Add New Note</h5>

                      <div className="text-end me-3 align-items-center d-flex">
                        <Label
                          htmlFor="formrow-firstname-Input"
                          className="mb-0"
                        >
                          Assign Task
                        </Label>
                        <div className="form-switch form-switch-md mb-2 mt-1">
                          <input
                            title="Intial Days"
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitchsizemd"
                            value={isNote}
                            onChange={e => setIsNote(e.target.checked)}
                          />
                        </div>
                      </div>
                    </div>
                    {isNote ? (
                      <div className="d-flex gap-2 flex-wrap">
                        <div className="col-12 mb-3">
                          <label htmlFor="">
                            Enter Task Name{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Enter Task Name"
                            value={taskName}
                            onChange={e => setTaskName(e.target.value)}
                            required
                          />
                        </div>
                        <div className="col-4 d-flex flex-column text-start  flex-wrap mb-3">
                          <label htmlFor="">
                            Assignee <span className="text-danger">*</span>
                          </label>
                          <ReactSelect
                            placeholder="Select Assignee"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            options={alldependency?.users}
                            value={assignee}
                            onChange={e => setAssignee(e)}
                          />
                        </div>
                        <div className="col-4 mb-3">
                          <label htmlFor="">
                            Priority <span className="text-danger">*</span>
                          </label>
                          <ReactSelect
                            placeholder="Select Task"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            options={priorityOption}
                            value={priority}
                            onChange={e => setPriority(e)}
                          />
                        </div>
                      </div>
                    ) : null}
                    <div className="" style={{ width: "98%" }}>
                      <label htmlFor="">Description</label>
                      <div className="no-drag">
                        <CKEditor
                          editor={ClassicEditor}
                          data={noteDescription || ""}
                          onReady={editor => {}}
                          onChange={(event, editor) => {
                            const data = editor.getData()
                            setNoteDescription(data)
                          }}
                        />
                      </div>
                    </div>
                    <div className="align-items-end d-flex justify-content-between mt-3">
                      <div className="col-md-6">
                        <label htmlFor="">Attachment</label>
                        <Dropzone
                          onDrop={acceptedFiles => {
                            handleAcceptedFiles1(acceptedFiles)
                          }}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div
                              className="dz-message needsclick p-0"
                              {...getRootProps()}
                            >
                              <input {...getInputProps()} />
                              <div className="d-flex px-2 custom-file-upload align-items-center">
                                <div className="">
                                  <i className="display-6 text-muted bx bxs-cloud-upload" />
                                </div>
                                <h5 className="mb-0 ms-2">Upload Files</h5>
                              </div>
                            </div>
                          )}
                        </Dropzone>
                        <div
                          className={`mt-2 dropzone-previews ${
                            selectedFiles1.length > 0 ? "d-block" : "d-none"
                          }`}
                          id="file-previews"
                        >
                          <label className="mb-1">Uploaded Files</label>
                          <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                            <div className="p-1">
                              <Row className="align-items-center justify-content-evenly">
                                {selectedFiles1.map((f, i) => {
                                  return (
                                    <Col key={i} className="col-auto">
                                      <img
                                        data-dz-thumbnail=""
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                        }}
                                        className="rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                      />
                                    </Col>
                                  )
                                })}
                              </Row>
                            </div>
                          </Card>
                        </div>
                      </div>
                      
                    </div>

                    <div className="text-end mt-3">
                      <button
                        className="btn btn-save  me-2 btn-label"
                        disabled={isLoading}
                      >
                        <i className="fas fa-save me-2 label-icon"></i> Submit
                        {isLoading && "ting..."}
                      </button>
                      <a
                        onClick={() => {
                          setAddTaskPopup(false)
                        }}
                        className=" btn ms-md-2 btn-red btn-label"
                      >
                        <i className="dripicons-cross me-2 icon-center label-icon"></i>
                        CANCEL
                      </a>
                    </div>
                  </form>
                </Row>
              </div>
            </div>
          </div>
        </Modal> */}

        <Modal
          size="xl"
          centered
          isOpen={addTaskPopup}
          className="modal-fullscreen"
        >
          <div className="modal-header py-2 justify-content-between align-items-start px-4 pt-4">
            <h5 className="modal-title mt-0">Add Task</h5>

            {type == "follow" ? (
              <>
                <Col className="company-info px-2 mb-3 me-0 d-flex justify-content-center align-items-center">
                  <div className="d-flex justify-content-start align-items-center gap-4">
                    <div>
                      <h5>
                        <i className="bi bi-buildings-fill text-purple"></i>{" "}
                        <span className="border-end border-3 border-dark pe-4 text-primary">
                          {followLeadData?.company || "--"}
                        </span>
                      </h5>
                    </div>

                    <div>
                      <h5>
                        <i className="bi bi-person-fill text-purple"></i>
                        <span className="border-end border-3 border-dark pe-4 text-primary">
                          {" "}
                          {getPersonName(followLeadData?.person_details) ||
                            "--"}
                        </span>{" "}
                      </h5>
                    </div>

                    <div>
                      <h5>
                        <i className="bi bi-telephone-fill text-purple"></i>
                        <span className="border-end border-3 border-dark pe-4 text-primary">
                          {" "}
                          {followLeadData?.phonenumber || "--"}
                        </span>{" "}
                      </h5>
                    </div>

                    <div>
                      <h5>
                        <i className="bi bi-envelope-fill text-purple"></i>{" "}
                        <span className="border-3 border-dark pe-4 text-primary">
                          {" "}
                          {followLeadData?.email || "--"}
                        </span>{" "}
                      </h5>
                    </div>
                  </div>
                </Col>
              </>
            ) : null}

            <div>
              <a
                onClick={() => {
                  setAddTaskPopup(false);
                  setActiveNoteTab("notes");
                  // setShowFollowCalendar(false);
                  setCurrentFollowupId("");
                }}
                className=""
              >
                <i className="dripicons-cross icon-center fs-5 text-dark"></i>
              </a>
            </div>
          </div>
          {type == "follow" ? (
            <div className="px-3 py-2 bg-light rounded-3 mx-4">
              <div className="fw-bold text-dark">Lead Description:</div>
              <div
                style={{
                  maxHeight: "100px",
                  overflow: "auto",
                  scrollbarWidth: "thin",
                }}
                dangerouslySetInnerHTML={{
                  __html: followLeadData?.description || "<div><div/>",
                }}
              />
            </div>
          ) : null}

          <div className="modal-body pe-4">
            <div className="row d-flex justify-content-center align-items-start mt-4">
              <div className="col-md-6 ps-3">
                <div className="d-flex gap-3 border-bottom pb-2 mb-3">
                  <h5
                    className={`cursor-pointer mb-0 pb-1 ${
                      activeNoteTab === "notes"
                        ? "text-purple border-bottom border-2"
                        : "text-muted"
                    }`}
                    style={{
                      borderColor:
                        activeNoteTab === "notes" ? "#762C99" : "transparent",
                    }}
                    onClick={() => setActiveNoteTab("notes")}
                  >
                    Notes History
                  </h5>
                  <h5
                    className={`cursor-pointer mb-0 pb-1 ${
                      activeNoteTab === "followup"
                        ? "text-purple border-bottom border-2"
                        : "text-muted"
                    }`}
                    style={{
                      borderColor:
                        activeNoteTab === "followup"
                          ? "#762C99"
                          : "transparent",
                    }}
                    onClick={() => setActiveNoteTab("followup")}
                  >
                    Follow Ups
                  </h5>
                </div>
                {activeNoteTab === "notes" && (
                  <div
                    className="mt-4"
                    style={{
                      maxHeight: "75vh",
                      overflowY: "auto",
                      scrollbarWidth: "thin",
                    }}
                  >
                    {allNotes.length === 0 ? (
                      <p className="text-muted text-center mt-4">
                        No follow ups found
                      </p>
                    ) : (
                      <ul className="verti-timeline list-unstyled notes-box">
                        {allNotes?.map((note, i) => {
                          return (
                            <li
                              className="event-list position-relative"
                              key={i}
                            >
                              <div className="event-timeline-dot connected-dot">
                                {note?.addedby_avatar ? (
                                  <img
                                    src={`${configure.imgUrl}/${note?.addedby_avatar}`}
                                    className="msgUserImg me-3 p-1 bg-light"
                                    alt={"A"}
                                  />
                                ) : (
                                  <div
                                    className="defualt-img event-timeline-dot connected-dot"
                                    title={note?.added_by}
                                  >
                                    {getInitials(note?.added_by || "Z")}
                                  </div>
                                )}
                              </div>

                              <div className="d-flex">
                                <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                                  <div className="d-flex justify-content-start align-items-center">
                                    <div>
                                      <p className="text-muted cursor-pointer">
                                        <h6 className="d-inline me-2">
                                          By {note.added_by}
                                        </h6>

                                        <Tooltip
                                          color="#f0e8f4"
                                          title={
                                            <div className="text-purple fw-bold body-font fs-6">
                                              <div>
                                                UK Time:{" "}
                                                {convertTimeZone(
                                                  note.created_at,
                                                  "Europe/London",
                                                  "DD-MM-YYYY hh:mm:ss a",
                                                )}
                                              </div>

                                              <div>
                                                US Time :{" "}
                                                {moment(note.created_at)
                                                  .tz("America/New_York")
                                                  .format(
                                                    "DD-MM-YYYY hh:mm:ss a",
                                                  )}
                                              </div>
                                            </div>
                                          }
                                        >
                                          {moment(note.created_at).format(
                                            "DD-MM-YYYY hh:mm:ss",
                                          )}
                                        </Tooltip>

                                        <span className="pl-15">
                                          Got in touch with this lead at{" "}
                                          <Tooltip
                                            color="#f0e8f4"
                                            title={
                                              <div className="text-purple fw-bold body-font fs-6">
                                                <div>
                                                  UK Time:{" "}
                                                  {convertTimeZone(
                                                    note.date,
                                                    "Europe/London",
                                                  )}
                                                </div>

                                                <div>
                                                  US Time :{" "}
                                                  {convertTimeZone(
                                                    note.date,
                                                    "America/New_York",
                                                    "DD-MM-YYYY hh:mm:ss a",
                                                  )}
                                                </div>
                                              </div>
                                            }
                                          >
                                            {moment(note.date).format(
                                              "DD-MM-YYYY hh:mm a",
                                            )}
                                          </Tooltip>
                                        </span>
                                      </p>
                                    </div>
                                  </div>

                                  <i className="bi bi-triangle-fill note-icon"></i>

                                  <div
                                    className="Features word-wrap"
                                    dangerouslySetInnerHTML={{
                                      __html: note.description,
                                    }}
                                  />

                                  <p className="mb-2">
                                    Amount : {note.currency_symbol}{" "}
                                    {note.amount}{" "}
                                  </p>

                                  {note.link != null ? (
                                    <p className="mb-1">
                                      Attachment :{" "}
                                      <a
                                        target="_blank "
                                        className="btn btn-sm edit-delete-btn text-secondary ml-10"
                                        rel="noreferrer"
                                        type="button"
                                        href={note.link}
                                      >
                                        <i className="fas fa-eye"></i> View
                                      </a>
                                    </p>
                                  ) : null}
                                </div>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </div>
                )}

                {activeNoteTab === "followup" && (
                  <div
                    className="mt-4"
                    style={{
                      maxHeight: "75vh",
                      overflowY: "auto",
                      scrollbarWidth: "thin",
                    }}
                  >
                    {allFollowups.length === 0 ? (
                      <p className="text-muted text-center mt-4">
                        No follow ups found
                      </p>
                    ) : (
                      <ul className="verti-timeline list-unstyled notes-box">
                        {allFollowups.map((followup, i) => (
                          <li key={i} className="event-list position-relative">
                            <div className="event-timeline-dot">
                              {followup.user_avatar ? (
                                <img
                                  src={`${configure.imgUrl}${followup.user_avatar}`}
                                  className="userImg me-3 "
                                  alt=""
                                />
                              ) : (
                                <div
                                  className="defualt-img"
                                  style={{ marginLeft: "-10px" }}
                                >
                                  {getInitials(followup.added_by || "z")}
                                </div>
                              )}
                            </div>
                            <div className="d-flex">
                              <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                                <div className="d-flex justify-content-between">
                                  <div>
                                    <p className="text-muted cursor-pointer">
                                      <h6 className="d-inline me-2">
                                        By {followup.added_by}
                                      </h6>{" "}
                                      <Tooltip
                                        color="#f0e8f4"
                                        title={
                                          <div className="text-purple fw-bold body-font fs-6">
                                            <div>
                                              UK Time:{" "}
                                              {convertTimeZone(
                                                followup.created_at,
                                                "Europe/London",
                                                "DD-MM-YYYY hh:mm:ss a",
                                              )}
                                            </div>
                                            <div>
                                              US Time:{" "}
                                              {convertTimeZone(
                                                followup.created_at,
                                                "America/New_York",
                                                "DD-MM-YYYY hh:mm:ss a",
                                              )}
                                            </div>
                                          </div>
                                        }
                                      >
                                        {moment(followup.created_at).format(
                                          "DD-MM-YYYY hh:mm:ss",
                                        )}
                                      </Tooltip>
                                      <span className="pl-15">
                                        {" "}
                                        Follow Up at{" "}
                                        <Tooltip
                                          color="#f0e8f4"
                                          title={
                                            <div className="text-purple fw-bold body-font fs-6">
                                              <div>
                                                UK Time:{" "}
                                                {convertTimeZone(
                                                  followup.date_time,
                                                  "Europe/London",
                                                  "DD-MM-YYYY hh:mm:ss a",
                                                )}
                                              </div>
                                              <div>
                                                US Time:{" "}
                                                {convertTimeZone(
                                                  followup.date_time,
                                                  "America/New_York",
                                                  "DD-MM-YYYY hh:mm:ss a",
                                                )}
                                              </div>
                                            </div>
                                          }
                                        >
                                          {moment(followup.date_time).format(
                                            "DD-MM-YYYY",
                                          )}
                                        </Tooltip>
                                      </span>
                                    </p>
                                  </div>
                                  <div className="me-4">
                                    {followup.status === 1 ? (
                                      <a
                                        className="btn btn-sm edit-delete-btn text-success me-2 disabled"
                                        title="Follow-up completed"
                                      >
                                        <i className="fas fa-check-circle"></i>
                                      </a>
                                    ) : (
                                      <a
                                        className="btn btn-sm edit-delete-btn text-success me-2"
                                        title="Mark follow-up as complete"
                                      >
                                        <i className="fas fa-check"></i>
                                      </a>
                                    )}
                                  </div>
                                </div>
                                <i className="bi bi-triangle-fill note-icon"></i>
                                <div
                                  className="Features"
                                  dangerouslySetInnerHTML={{
                                    __html: followup.description,
                                  }}
                                />
                                <div
                                  className="Features"
                                  // dangerouslySetInnerHTML={{
                                  //   __html: followup.assign_user_name,
                                  // }}
                                >
                                  Assigned to:{" "}
                                  {followup.assign_user_name || "N/A"}
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
              </div>

              <div className="col-md-6 d-flex flex-column justify-space-between  gap-3">
                <Row className="align-items-center justify-content-between">
                  <form onSubmit={(e) => onActionNewLead(e)}>
                    <div className="col-12 d-flex justify-content-between">
                      <h5 className="text-dark">Add New Note</h5>

                      <div className="text-end me-3 align-items-center d-flex">
                        <Label
                          htmlFor="formrow-firstname-Input"
                          className="mb-0"
                        >
                          Assign Task
                        </Label>
                        <div className="form-switch form-switch-md mb-2 mt-1">
                          <input
                            title="Intial Days"
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitchsizemd"
                            value={isNote}
                            onChange={(e) => setIsNote(e.target.checked)}
                          />
                        </div>
                      </div>
                    </div>
                    {isNote ? (
                      <div className="d-flex gap-2 flex-wrap">
                        <div className="col-12 mb-3">
                          <label htmlFor="">
                            Enter Task Name{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Enter Task Name"
                            value={taskName}
                            onChange={(e) => setTaskName(e.target.value)}
                            required
                          />
                        </div>
                        <div className="col-4 d-flex flex-column text-start  flex-wrap mb-3">
                          <label htmlFor="">
                            Assignee <span className="text-danger">*</span>
                          </label>
                          <ReactSelect
                            placeholder="Select Assignee"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            options={alldependency?.users}
                            value={assignee}
                            onChange={(e) => setAssignee(e)}
                          />
                        </div>
                        <div className="col-4 mb-3">
                          <label htmlFor="">
                            Priority <span className="text-danger">*</span>
                          </label>
                          <ReactSelect
                            placeholder="Select Task"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            options={priorityOption}
                            value={priority}
                            onChange={(e) => setPriority(e)}
                          />
                        </div>
                      </div>
                    ) : null}
                    <div className="" style={{ width: "98%" }}>
                      <label htmlFor="">Description</label>
                      <div className="no-drag">
                        <CKEditor
                          editor={ClassicEditor}
                          data={noteDescription || ""}
                          onReady={(editor) => {}}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setNoteDescription(data);
                          }}
                        />
                      </div>
                    </div>
                    <div className="align-items-end d-flex justify-content-between mt-3">
                      <div className="col-md-6">
                        <label htmlFor="">Attachment</label>
                        <Dropzone
                          onDrop={(acceptedFiles) => {
                            handleAcceptedFiles1(acceptedFiles);
                          }}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div
                              className="dz-message needsclick p-0"
                              {...getRootProps()}
                            >
                              <input {...getInputProps()} />
                              <div className="d-flex px-2 custom-file-upload align-items-center">
                                <div className="">
                                  <i className="display-6 text-muted bx bxs-cloud-upload" />
                                </div>
                                <h5 className="mb-0 ms-2">Upload Files</h5>
                              </div>
                            </div>
                          )}
                        </Dropzone>
                        <div
                          className={`mt-2 dropzone-previews ${
                            selectedFiles1.length > 0 ? "d-block" : "d-none"
                          }`}
                          id="file-previews"
                        >
                          <label className="mb-1">Uploaded Files</label>
                          <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                            <div className="p-1">
                              <Row className="align-items-center justify-content-evenly">
                                {selectedFiles1.map((f, i) => {
                                  return (
                                    <Col key={i} className="col-auto">
                                      <img
                                        data-dz-thumbnail=""
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                        }}
                                        className="rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                      />
                                    </Col>
                                  );
                                })}
                              </Row>
                            </div>
                          </Card>
                        </div>
                      </div>
                      <div className="col-4 text-end d-flex align-items-center justify-content-end">
                        <Label
                          htmlFor="formrow-firstname-Input"
                          className="mb-0"
                        >
                          Follow Up
                        </Label>
                        <div className="form-switch form-switch-md mb-2 mt-1">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitchsizemd"
                            checked={isFollowUp}
                            onChange={(e) => {
                              if (!e.target.checked) {
                                setFollowdate("");
                                setAssignes([]);
                                setFollowDescription("");
                              }
                              setIsFollowUp(e.target.checked);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {isFollowUp && (
                      <Row className="align-items-center ">
                        <h6 className="mt-4 pb-2 fw-semibold border-bottom text-purple">
                          Follow Up Details
                        </h6>
                        <div className="col-md-4 notes">
                          <label htmlFor="touch">
                            Follow up date{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="date"
                            required
                            value={followdate}
                            onChange={(e) => setFollowdate(e.target.value)}
                            className="form-control "
                          />
                        </div>
                        <div className="col-md-8">
                          <label htmlFor="">Follow up assigned</label>
                          <Select
                            onChange={(e) => setAssignes(e)}
                            placeholder="Select"
                            className="basic-multi-select"
                            classNamePrefix=" select"
                            value={assignes}
                            styles={colourStyles}
                            isMulti
                            options={alldependency?.users}
                          />
                        </div>

                        <div className="col-12 my-3">
                          <label htmlFor="">Purpose</label>
                          <textarea
                            className="form-control"
                            placeholder="Enter Purpose"
                            value={followdescription}
                            onChange={(e) =>
                              setFollowDescription(e.target.value)
                            }
                            style={{ height: "65px" }}
                          ></textarea>
                        </div>
                      </Row>
                    )}

                    <div className="text-end mt-3">
                      <button
                        className="btn btn-save  me-2 btn-label"
                        disabled={isLoading}
                      >
                        <i className="fas fa-save me-2 label-icon"></i> Submit
                        {isLoading && "ting..."}
                      </button>
                      <a
                        onClick={() => {
                          setAddTaskPopup(false);
                          setActiveNoteTab("notes");
                        }}
                        className=" btn ms-md-2 btn-red btn-label"
                      >
                        <i className="dripicons-cross me-2 icon-center label-icon"></i>
                        CANCEL
                      </a>
                    </div>
                  </form>
                </Row>
              </div>
            </div>
          </div>
        </Modal>

        {/** notes followup module pop up */}
        <Modal
          isOpen={showNotesPopup}
          size="xl"
          className="bd-custom-modal-lg"
          centered
          backdrop={false}
        >
          <div className="modal-header justify-content-between">
            <h5 className="modal-title mt-0">
              {nextFollowupMode ? "Add Next Follow-up" : "Lead Notes"}
            </h5>

            <button
              type="button"
              className="btn-modal-close"
              // onClick={() => setShowNotesPopup(false)}
              onClick={() => {
                Swal.fire({
                  icon: "question",
                  title: "Did you add a note?",
                  text: "If you haven't added a note or follow-up yet, it will be reminded next time.",
                  showCancelButton: true,
                  confirmButtonText: "Yes, I'm done",
                  cancelButtonText: "Go back",
                  confirmButtonColor: "#762C99",
                }).then((result) => {
                  if (result.isConfirmed) {
                    localStorage.removeItem("notes_pending_session"); // session complete
                    setNextFollowupMode(false);
                    setShowNotesPopup(false);
                  }
                  // if cancelled, modal stays open
                });
              }}
            >
              <span aria-hidden="true" className="btn-modal-span">
                &times;
              </span>
            </button>
          </div>

          <div
            className="modal-body"
            style={{ maxHeight: "80vh", overflowY: "auto" }}
          >
            <Notes
              lead_id={notesLeadId}
              noteData={note_data || []}
              assigned={assigned_data || []}
              verticalActiveTab="2"
              subtasks={subtasks}
              autoOpenFollowup={nextFollowupMode}
              onFollowupAdded={handleNextFollowupAdded}
            />
          </div>
        </Modal>

        <div
          className={`note-sticky-form ${
            tenderTaskModal ? "d-block" : "d-none"
          }`}
        >
          <Draggable
            handle={`${noDrag ? ".modal-header" : ""}`}
            cancel={`${noDrag ? ".modal-body" : ""}`}
          >
            <ResizableBox
              width={boxWidth}
              style={{
                position: "fixed",
                top: "16%",
                right: "18%",
                zIndex: "1055",
                backgroundColor: "#fff",
                maxHeight: "fit-content",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div className="modal-header py-2 justify-content-between align-items-start">
                <h5 className="modal-title mt-0">Add Task</h5>

                <div>
                  <a
                    onClick={() => {
                      setTenderTaskModal(false);
                    }}
                    className=""
                  >
                    <i className="dripicons-cross icon-center fs-5 text-dark"></i>
                  </a>
                </div>
              </div>

              <div className="modal-body pe-4">
                <div className="row d-flex justify-content-center align-items-start mt-4">
                  {/* working */}
                  <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
                    <div className="text-center">
                      <img
                        src={AddTaskImg}
                        alt="Addepe"
                        style={{ width: "80%" }}
                      />
                    </div>
                  </div>

                  <div className="col-md-6 d-flex flex-column justify-space-between  gap-3">
                    <Row className="align-items-center justify-content-between">
                      <form onSubmit={(e) => onAddTenderNote(e)}>
                        <div className="col-12 d-flex justify-content-between">
                          <h5 className="text-dark">Add New Note</h5>
                          <div className="text-end me-3 align-items-center d-flex">
                            <Label htmlFor="formrow-firstname-Input">
                              Assign Task
                            </Label>
                            <div className="form-switch form-switch-md mb-2 mt-1">
                              <input
                                title="Intial Days"
                                type="checkbox"
                                className="form-check-input"
                                id="customSwitchsizemd"
                                value={isNote}
                                onChange={(e) => setIsNote(e.target.checked)}
                              />
                            </div>
                          </div>
                        </div>
                        {isNote ? (
                          <div className="d-flex gap-2 flex-wrap">
                            <div className="col-12 mb-3">
                              <label htmlFor="">
                                Enter Task Name{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <Input
                                type="text"
                                className="form-control"
                                placeholder="Enter Task Name"
                                value={taskName}
                                onChange={(e) => setTaskName(e.target.value)}
                                required
                              />
                            </div>
                            <div className="col-4 d-flex flex-column text-start  flex-wrap mb-3">
                              <label htmlFor="">
                                Assignee <span className="text-danger">*</span>
                              </label>
                              <ReactSelect
                                placeholder="Select Assignee"
                                className="basic-multi-select"
                                classNamePrefix="select"
                                options={alldependency?.users}
                                value={assignee}
                                onChange={(e) => setAssignee(e)}
                              />
                            </div>
                            <div className="col-4 mb-3">
                              <label htmlFor="">
                                Priority <span className="text-danger">*</span>
                              </label>
                              <ReactSelect
                                placeholder="Select Task"
                                className="basic-multi-select"
                                classNamePrefix="select"
                                options={priorityOption}
                                value={priority}
                                onChange={(e) => setPriority(e)}
                              />
                            </div>
                          </div>
                        ) : null}
                        <div className="" style={{ width: "98%" }}>
                          <label htmlFor="">Description</label>
                          <div className="no-drag">
                            <CKEditor
                              editor={ClassicEditor}
                              data={noteDescription || ""}
                              onReady={(editor) => {}}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setNoteDescription(data);
                              }}
                            />
                          </div>
                        </div>
                        <div className="text-end mt-3">
                          <button className="btn btn-save  me-2 btn-label">
                            <i className="fas fa-plus me-2 label-icon"></i>Add
                            Note
                          </button>
                          <a
                            onClick={() => {
                              setTenderTaskModal(false);
                            }}
                            className=" btn ms-md-2 btn-red btn-label"
                          >
                            <i className="dripicons-cross me-2 icon-center label-icon"></i>
                            CANCEL
                          </a>
                        </div>
                      </form>
                    </Row>
                  </div>
                </div>
              </div>
            </ResizableBox>
          </Draggable>
        </div>
        {/* </ResizableBox>
          </Draggable> */}
        {/* </div> */}
      </div>
      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  );
};

export default React.memo(GeneralTask);
